import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosService } from 'app/services/parametros.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ListaClienteComponent } from './lista-cliente/lista-cliente.component';
import { ComprobantesService } from 'app/services/comprobantes.service';
import { ListaProductosDialogoComponent } from '../lista-productos-dialogo/lista-productos-dialogo.component';
import { CajaService } from 'app/services/caja.service';
import dayjs from 'dayjs';
import { DataService } from 'app/services/data.service';
import { Voucher } from 'app/models/voucher.models';
import { Currencie } from 'app/models/currencie.models';
import { Client } from 'app/models/client.models';
import { Header } from 'app/models/header.models';
import { Detail } from 'app/models/detail.models';
import { MeasurementUnit } from 'app/models/umedida.models';
import { forkJoin, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UploadFileComponent } from 'app/shared/upload-file/upload-file.component';
import { ListaprecioService } from 'app/services/listaprecio.service';
import { ProductoService } from 'app/services/producto.service';
import { EmpresaService } from 'app/services/empresa.service';
import { ImpresionService } from 'app/services/impresion.service';
import { ListaPrecio } from 'app/models/listaprecio.models';
import { VoucherTypes } from 'app/models/vouchertype.models'; 
import { ReceiptBook } from 'app/models/receiptbook.models';
import { Tributo } from 'app/models/tributo.models';
import Swal from 'sweetalert2';

// Interface para el mapeo de códigos de comprobantes
interface CodigosComprobantes {
  [tipoOperacion: string]: {
    [tipoComprobante: string]: string;
  };
}

@Component({
  selector: 'app-comprobante',
  templateUrl: './comprobante.component.html',
  styleUrls: ['./comprobante.component.css'],
})
export class ComprobanteComponent implements OnInit, OnDestroy {
  @ViewChild('cantidad') cantidadTabla: ElementRef;
  @ViewChild('detalleLibreModal') detalleLibreModal: TemplateRef<any>;
  @ViewChild('dialogoTributos') dialogoTributos: TemplateRef<any>;

  // Mapa centralizado de códigos de comprobantes
  private static readonly CODIGOS_COMPROBANTES: CodigosComprobantes = {
    ventas: {
      'pedido': '999',        // Pedido de venta
      'presupuesto': '903',   // Presupuesto de venta
      'remito': '091',        // Remito de venta
      'recibo': '004',        // Recibo
      'factura': '001',       // Factura A/B/C
      'notadecredito': '003', // Nota de crédito
      'notadedebito': '002'   // Nota de débito
    },
    compras: {
      'pedido': '998',        // Pedido de compra
      'presupuesto': '902',   // Presupuesto de compra
      'remito': '092',        // Remito de compra
      'recibo': '005',        // Recibo de compra
      'factura': '006',       // Factura de compra
      'notadecredito': '007', // Nota de crédito de compra
      'notadedebito': '008'   // Nota de débito de compra
    }
  };

  conceptos = [];
  otrostributos = [];
  typeivas = [];
  monedas: Currencie[] = [];
  typeComprobantes:VoucherTypes[] = [];
  medidas: MeasurementUnit[] = [];
  tiposarticulos = [];
  marcas = [];
  rubros = []; // Rubros
  form: UntypedFormGroup;
  cliente: Client;
  textoBtn: string;
  subtotal = 0;
  total = 0;
  bonificacion = 0;
  impuestos = 0;
  netoGravado = 0;
  totalIva = 0;
  desgloseIva: Array<{percentage: number, baseAmount: number, amount: number}> = [];
  comprobante: Voucher;
  cabecera: Header;
  bonif: number;
  fecha = new UntypedFormControl(new Date());
  fechaDesde = new UntypedFormControl(new Date());
  fechaHasta = new UntypedFormControl(new Date());
  verFechasDesdeHasta: boolean;

  sidebar: HTMLElement;
  typeComprobanteDB;
  nro: number;
  punto: number;
  type: string;
  operacion: string;
  typeComprobante: string;
  typeCliente;
  urlComprobante: string | null = null;
  
  // Propiedad para almacenar el ID del comprobante cuando estamos en modo edición
  comprobanteId: number | null = null;
  // Nuevas propiedades para detalles libres
  detalleLibreForm: UntypedFormGroup;
  dialogRef: MatDialogRef<any>;
  
  // Propiedad para el spinner de carga
  isCreatingVoucher = false;

  // Nuevas propiedades para comprobantes relacionados
  comprobantesRelacionados: Voucher[] = [];
  comprobanteRelacionado: Voucher | null = null;

  // Nueva propiedad para listas de precios
  priceLists: ListaPrecio[] = [];

  // Nueva propiedad para tributos
  tributoForm: UntypedFormGroup;

  // Array para almacenar los tributos del comprobante actual
  tributosComprobante: Array<{
    nombre: string, 
    monto: number, 
    tipo: 'monto' | 'porcentaje', 
    porcentaje?: number,
    aplicadoSobre?: number,
    tributoId?: number
  }> = [];

  // Nuevas propiedades para talonarios
  talonarios: ReceiptBook[] = [];
  talariosFiltrados: ReceiptBook[] = [];

  // Nueva propiedad para condiciones de venta
  saleConditions: any[] = [];
  
  // Propiedad para almacenar los datos del comprobante hasta que se carguen los parámetros
  private datosComprobanteParaCargar: Voucher | null = null;

  // Lista de tributos disponibles desde el endpoint /tax
  tributosDisponibles: Tributo[] = [];

  // Tributo actualmente seleccionado en el diálogo
  tributoSeleccionado: Tributo | null = null;

  // Suscripción para la lista de artículos
  private articulosSubscription: Subscription;

  // Propiedades para totales flotantes
  totalesFlotantesMinimizados = false;
  private scrollThreshold = 200; // Píxeles de scroll antes de mostrar totales flotantes

  constructor(
    private fb: UntypedFormBuilder,
    public cajaService: CajaService,
    private _snackBar: MatSnackBar,
    private parametroServicio: ParametrosService,
    public dialog: MatDialog,
    private routerActive: ActivatedRoute,
    private router: Router,
    private comprobanteSerice: ComprobantesService,
    private dataService: DataService,
    private listaprecioService: ListaprecioService,
    private productoService: ProductoService,
    private empresaService: EmpresaService,
    private impresionService: ImpresionService
  ) {
    this.comprobante = new Voucher();
    this.cabecera = new Header();
    this.typeComprobante = this.routerActive.snapshot.params.typecomprobante;
    this.type = this.routerActive.snapshot.params.type;
    this.operacion = this.routerActive.snapshot.params.operacion;
    
    // Capturar el ID del comprobante cuando estamos en modo edición
    if (this.routerActive.snapshot.params.id) {
      // Si viene por la ruta /comprobante/:type/edit/:id
      this.comprobanteId = Number(this.routerActive.snapshot.params.id);
      this.operacion = 'edit';
    } else if (this.operacion === 'edit') {
      // Si viene por la ruta antigua donde el ID está en typecomprobante
      this.comprobanteId = Number(this.typeComprobante) || null;
    }
    
    if (this.type === 'ventas') {
      this.typeCliente = 'cliente';
    } else {
      this.typeCliente = 'proveedor';
    }
    this.form = this.fb.group({
      talonario: ['', Validators.required], // Cambiar de valor fijo a campo requerido
      numero: [1],
      cliente: [''],
      fecha: [''],
      salesPointsId: [1],
      puntoVentaManual: [''], // Campo para punto de venta manual en compras
      numeroComprobanteManual: [''], // Campo para número de comprobante manual en compras
      codebarra: [''],
      concepto: [''],
      impuestos: [''],
      comentario: [''],
      iva: [''],
      moneda: [''],
      posicioniva: ['grabado'],
      listaprecio: [''],
      priceListId: ['', Validators.required], // Nuevo campo para lista de precios
      comprobanteRelacionadoId: [''], // Nuevo campo para comprobante relacionado
      cae: [''], // Campo para CAE
      fechaVencimientoCae: [''], // Campo para fecha de vencimiento CAE
      condiventa: [''], // Campo para condición de venta
      fechaEntrega: [''], // Campo para fecha de entrega requerida (pedidos de compra)
      depositoDestino: [''], // Campo para depósito de destino (pedidos de compra)
    });

    // Inicializar formulario de detalles libres
    this.detalleLibreForm = this.fb.group({
      codigo: ['', Validators.required], // Nuevo campo para código personalizado
      descripcion: ['', Validators.required],
      cantidad: [1, [Validators.required, Validators.min(0.01)]],
      unidad: ['', Validators.required],
      precio: [0, [Validators.required, Validators.min(0.01)]],
      bonificacion: [0, [Validators.min(0), Validators.max(100)]],
      bonificacionImporte: [0, [Validators.min(0)]],
    });

    // Inicializar formulario de tributos
    this.tributoForm = this.fb.group({
      tributoId: ['', Validators.required], // ID del tributo seleccionado
      tipo: ['monto', Validators.required], // 'monto' o 'porcentaje'
      monto: [0, [Validators.min(0)]],
      porcentaje: [0, [Validators.min(0), Validators.max(100)]],
      descripcionPersonalizada: [''] // Descripción personalizada opcional
    });

    if (this.operacion === 'create') {
      this.textoBtn = 'Crear';
    } else {
      this.textoBtn = 'Actualizar';
      // En modo edición, usar el ID del comprobante que capturamos
      if (this.comprobanteId) {
        this.comprobanteSerice.getComprobanteById(this.comprobanteId).subscribe(
          res => {
            // Obtener el nombre del tipo de comprobante desde voucherTypesCode
            this.typeComprobante = res.voucherType?.voucherTypesCode?.name || res.voucherType?.description || 'Comprobante';
            
            // Almacenar los datos para aplicarlos después de cargar los parámetros
            this.datosComprobanteParaCargar = res;

            // Si el comprobante tiene un comprobante relacionado, lo cargamos
            if (res.relatedVoucherId) {
              this.comprobanteSerice.getComprobanteById(res.relatedVoucherId).subscribe(
                relacionado => {
                  this.comprobanteRelacionado = relacionado;
                  this.form.controls.comprobanteRelacionadoId.setValue(relacionado.id);
                },
                err => console.log(err)
              );
            }
          },
          err => {
            console.log(err);
            this._snackBar.open('Error al cargar el comprobante', 'Cerrar', {
              duration: 3000,
            });
          }
        );
      }
    }

    this.form.controls.concepto.valueChanges.subscribe(r => {
      // buscamos en la lista de conceptos el que tenga el id ingresado
      const concepto = this.conceptos.find(x => x.id === r);
      // si el concepto es 'Servicios' o 'Productos y Servicios' habilitamos los campos de fecha
      // de lo contrario los deshabilitamos
      if (concepto) {
        if (
          concepto.description === 'Servicios' ||
          concepto.description === 'Productos y Servicios'
        ) {
          this.verFechasDesdeHasta = true;
          this.fechaDesde.enable();
          this.fechaHasta.enable();
        } else {
          this.verFechasDesdeHasta = false;
          this.fechaDesde.disable();
          this.fechaHasta.disable();
        }
      }
    });

    // Al seleccionar un comprobante relacionado, cargar sus datos
    this.form.controls.comprobanteRelacionadoId.valueChanges.subscribe(id => {
      if (id) {
        const comprobante = this.comprobantesRelacionados.find(
          c => c.id === parseInt(id)
        );
        if (comprobante) {
          this.comprobanteRelacionado = comprobante;
        }
      } else {
        this.comprobanteRelacionado = null;
      }
    });

    // Nuevo: Suscribirse a cambios en la lista de precios
    this.form.controls.priceListId.valueChanges.subscribe(priceListId => {
      if (priceListId !== null && priceListId !== undefined && priceListId !== '' && this.cajaService.articulosList.length > 0) {
        this.actualizarPreciosArticulos(priceListId);
      }
    });

    // Suscribirse a cambios en el campo cliente para manejar cuando se limpie
    this.form.controls.cliente.valueChanges.subscribe(clienteValue => {
      // Si el campo cliente se vacía, deshabilitar y limpiar el talonario
      if (!clienteValue || clienteValue.trim() === '') {
        this.cliente = null;
        this.form.controls.talonario.disable();
        this.form.controls.talonario.setValue('');
      }
    });

    this.form.controls.moneda.disable();
    
    // Habilitar el talonario desde el inicio para debugging
    // this.form.controls.talonario.disable();
  }

  ngOnDestroy(): void {
    this.cajaService.articulosList = [];
    // Cerrar la suscripción para evitar memory leaks
    if (this.articulosSubscription) {
      this.articulosSubscription.unsubscribe();
    }
    // Limpiar eventos de scroll
    this.destroyTotalesFlotantes();
  }

  ngOnInit(): void {
    this.sidebar = <HTMLElement>document.querySelector('.navbar-brand');
    if (this.sidebar !== undefined) {
      this.sidebar.innerHTML = 'Comprobante';
    }
    
    // Suscribirse a los cambios en la lista de artículos para recalcular totales automáticamente
    this.articulosSubscription = this.cajaService.lstArticulos.subscribe(() => {
      // Solo recalcular si hay artículos en la lista
      if (this.cajaService.articulosList.length > 0) {
        this.sumarTotalProductos();
      }
    });
    
    // Si es operación de compra, hacer obligatorios los campos manuales
    this.configurarValidadoresCompra();
    
    // Inicializar sistema de totales flotantes
    this.initTotalesFlotantes();
    
    // Cargar preferencia del usuario para totales flotantes
    const preferencia = localStorage.getItem('totalesFlotantesMinimizados');
    if (preferencia !== null) {
      this.totalesFlotantesMinimizados = preferencia === 'true';
    }
    
    this.getParametros();
  }

  /**
   * Configura los validadores para los campos de compra
   */
  private configurarValidadoresCompra() {
    if (this.esOperacionCompra() && !this.esPedidoDeCompra()) {
      // Hacer obligatorios los campos de punto de venta y número SOLO para compras que NO sean pedidos
      // Los pedidos de compra no requieren estos campos porque son datos de la futura factura del proveedor
      this.form.controls.puntoVentaManual.setValidators([Validators.required, Validators.min(1)]);
      this.form.controls.numeroComprobanteManual.setValidators([Validators.required, Validators.min(1)]);
      
      // Actualizar el estado de validación
      this.form.controls.puntoVentaManual.updateValueAndValidity();
      this.form.controls.numeroComprobanteManual.updateValueAndValidity();
      
      console.log('🔒 Validadores de compra configurados - campos obligatorios para facturas/remitos/notas');
    } else if (this.esPedidoDeCompra()) {
      // Para pedidos de compra, limpiar los validadores de estos campos
      this.form.controls.puntoVentaManual.clearValidators();
      this.form.controls.numeroComprobanteManual.clearValidators();
      
      // Actualizar el estado de validación
      this.form.controls.puntoVentaManual.updateValueAndValidity();
      this.form.controls.numeroComprobanteManual.updateValueAndValidity();
      
      console.log('📋 Pedido de compra detectado - campos de factura del proveedor no requeridos');
    }
  }

  getParametros() {
    // Cargar datos de comprobantes, artículos, listas de precios y tributos en paralelo usando forkJoin
    forkJoin({
      comprobantes: this.parametroServicio.getParametrosComprobantes(),
      articulos: this.parametroServicio.getParametrosArticulos(),
      listaPrecios: this.listaprecioService.getListaPrecios(),
      tributos: this.parametroServicio.getTributos(),
    }).subscribe(
      ({ comprobantes, articulos, listaPrecios, tributos }) => {
        // Datos de comprobantes
        this.monedas = comprobantes.currencies;
        this.typeivas = comprobantes.vatRates;
        this.conceptos = comprobantes.concepts;
        this.otrostributos = comprobantes.taxes;
        this.saleConditions = comprobantes.saleConditions || [];
        
        // Debug: Mostrar los conceptos disponibles para verificar los nombres exactos
        console.log('Conceptos disponibles:', this.conceptos.map(c => ({ id: c.id, description: c.description })));
        
        // Datos de tributos desde el endpoint /tax
        this.tributosDisponibles = tributos || [];
        
        // Crear typeComprobantes desde los talonarios si voucherTypes no está disponible
        if (comprobantes.voucherTypes && Array.isArray(comprobantes.voucherTypes)) {
          this.typeComprobantes = comprobantes.voucherTypes;
        } else {
          // Extraer voucherTypes únicos de los talonarios
          const voucherTypesMap = new Map();
          if (comprobantes.receiptBooks && Array.isArray(comprobantes.receiptBooks)) {
            comprobantes.receiptBooks.forEach(talonario => {
              if (talonario.voucherType && !voucherTypesMap.has(talonario.voucherType.id)) {
                voucherTypesMap.set(talonario.voucherType.id, talonario.voucherType);
              }
            });
          }
          this.typeComprobantes = Array.from(voucherTypesMap.values());
        }
        
        // Usar parameters.receiptBooks para establecer los talonarios
        this.talonarios = comprobantes.parameters?.receiptBooks || comprobantes.receiptBooks || [];
        
        // 🔍 DEBUG: Mostrar estructura completa de talonarios
        console.log('🏢 === ANÁLISIS DE TALONARIOS ===');
        console.log(`📊 Total de talonarios cargados: ${this.talonarios.length}`);
        this.talonarios.forEach(talonario => {
          console.log(`\n📦 Talonario ID ${talonario.id}:`, {
            description: talonario.description,
            code: talonario.code,
            // Campos de tipo de operación
            'operation': talonario.operation,
            'receiptBookType.value': talonario.receiptBookType?.value,
            'receiptBookType.name': talonario.receiptBookType?.name,
            'voucherType.operationType': talonario.voucherType?.operationType,
            // Tipo de comprobante
            'voucherType.voucherTypesCode.name': talonario.voucherType?.voucherTypesCode?.name,
            'voucherType.description': talonario.voucherType?.description,
            // Letra del comprobante
            'receiptBookLetter.letter': talonario.receiptBookLetter?.letter,
            // Punto de venta
            'salesPointsId': talonario.salesPointsId,
            'salesPoint.number': talonario.salesPoint?.number
          });
        });
        console.log('🏢 === FIN ANÁLISIS DE TALONARIOS ===\n');


        // Datos de artículos
        this.medidas = articulos.umedidas || [];
        this.marcas = articulos.marcas || [];
        this.rubros = articulos.rubros || [];
        this.tiposarticulos = articulos.tiposarticulos || [];

        // Si estamos editando un comprobante y ya tenemos artículos cargados,
        // procesarlos para establecer las unidades de medida
        if (this.operacion === 'edit' && this.cajaService.articulosList && this.cajaService.articulosList.length > 0) {
          this.procesarArticulosParaEdicion();
        }

        // Cargar listas de precios
        this.priceLists = listaPrecios || [];

        // Si solo hay una lista de precios, seleccionarla automáticamente
        if (this.priceLists.length === 1) {
          this.form.controls.priceListId.setValue(this.priceLists[0].id);
        }

        // Procesamiento de conceptos
        let indiceOtros = this.conceptos.findIndex(x =>
          x.description?.toLowerCase()?.includes('otros')
        );
        if (indiceOtros >= 0) {
          this.conceptos.splice(indiceOtros, 1);
        }

        // Configurar valores predeterminados
        let concepto = this.conceptos.find(x => x.code === '1');
        this.form.controls.concepto.setValue(concepto?.id, {
          onlySelf: true,
        });

        let type = this.typeivas.find(x => x.code === '5');
        this.form.controls.iva.setValue(type?.id, {
          onlySelf: true,
        });

        let moneda = this.monedas.find(x => x.code === 'PES');
        this.form.controls.moneda.setValue(moneda?.id, {
          onlySelf: true,
        });

        // Configurar condición de venta predeterminada usando los datos de parámetros
        if (this.saleConditions && this.saleConditions.length > 0) {
          // Buscar condición de venta por defecto o la primera disponible
          let condicionVentaDefault = this.saleConditions.find(x => x.isDefault === true) || 
                                      this.saleConditions.find(x => x.code === 'contado') ||
                                      this.saleConditions[0];
          
          if (condicionVentaDefault) {
            this.form.controls.condiventa.setValue(condicionVentaDefault.code || condicionVentaDefault.id, {
              onlySelf: true,
            });
          }
        }
        
        // Configurar tipo de comprobante usando el método mejorado
        this.typeComprobanteDB = this.obtenerTipoComprobanteDB();
        
        // Si no encontramos typeComprobanteDB específico para factura,
        // intentemos un enfoque más directo basado en los talonarios disponibles
        if (!this.typeComprobanteDB && this.typeComprobante === 'factura') {
          const facturaReceiptBook = this.talonarios.find(rb => {
            const esFactura = rb.voucherType?.voucherTypesCode?.name === 'Factura';
            const esVenta = (rb as any).receiptBookType?.value === 'sales' || rb.operation === 'venta';            
            return esFactura && esVenta;
          });
          
          if (facturaReceiptBook) {
            this.typeComprobanteDB = facturaReceiptBook.voucherType;
          }
        }
        
        // Filtrar talonarios según el tipo de comprobante
        this.filtrarTalonarios();
        
        // Configurar valores por defecto después de cargar todos los parámetros
        this.configurarValoresPorDefecto();
        
        // Configurar listener para cambios en el talonario (para actualizar el título y sidebar)
        this.form.get('talonario')?.valueChanges.subscribe((talonarioId) => {
          if (talonarioId) {
            this.onTalonarioChange(talonarioId);
          }
        });
        
        if (this.operacion === 'create') {
          this.getNumeroComprobante();
        }
        
        // Si estamos en modo edición y tenemos datos del comprobante pendientes, aplicarlos ahora
        if (this.operacion === 'edit' && this.datosComprobanteParaCargar) {
          const datosTemp = this.datosComprobanteParaCargar; // Guardar referencia antes de borrar
          this.setDatosComprobante(this.datosComprobanteParaCargar);
          this.datosComprobanteParaCargar = null; // Limpiar los datos almacenados
          
          // Actualizar el sidebar después de que los talonarios estén cargados
          this.actualizarSidebarConDatos(datosTemp);
        }
      },
      err => {
        console.log(err);
        this.openSnackBar('Error al cargar parámetros', 'Error');
      }
    );
  }

  /**
   * Configura valores por defecto específicos para comprobantes
   */
  configurarValoresPorDefecto() {
    // Solo configurar valores por defecto al crear nuevos comprobantes
    if (this.operacion !== 'create') {
      return;
    }

    // 1. Establecer "CONSUMIDOR FINAL" como cliente por defecto
    this.establecerConsumidorFinalPorDefecto();

    // 2. Si la ruta es comprobante/ventas/create/presupuesto, configurar talonario de presupuesto
    this.configurarTalonarioPresupuesto();
  }

  /**
   * Establece "CONSUMIDOR FINAL" como cliente por defecto (solo para ventas)
   */
  private establecerConsumidorFinalPorDefecto() {
    // Si es operación de compra, NO establecer cliente por defecto
    // El usuario debe seleccionar manualmente un proveedor
    if (this.esOperacionCompra()) {
      console.log('📦 Operación de compra detectada - esperando selección de proveedor');
      return;
    }

    // Crear cliente consumidor final por defecto - ID fijo = 1 (solo para ventas)
    const consumidorFinal: Client = {
      id: 1, // ID fijo para consumidor final en el sistema
      number: 1,
      companyName: 'CONSUMIDOR FINAL',
      documentNumber: '99999999999', // CUIT genérico para consumidor final
      email: 'consumidor@final.com',
      phone: '',
      address: 'S/D',
      city: 'S/D',
      state: 'S/D',
      postalCode: '0000',
      country: 'Argentina',
      type: 'consumidor_final',
      responsibleTypeId: 1, // 1 = Consumidor Final (no-RI)- debe usar Factura C
      observations: 'Cliente consumidor final por defecto'
    };

    // Establecer en el formulario y componente
    this.cliente = consumidorFinal;
    this.form.controls.cliente.setValue('CONSUMIDOR FINAL');
    
    // Habilitar el talonario ya que tenemos un cliente por defecto
    this.form.controls.talonario.enable();

    // Aplicar filtrado fiscal y seleccionar automáticamente Factura C para Consumidor Final
    console.log('🎯 Cliente Consumidor Final - aplicando filtrado fiscal para Factura C');
    this.filtrarTalonarios();
    this.seleccionarTalonarioAutomatico();
  }

  /**
   * Configura el talonario de presupuesto para ventas o pedido para compras si corresponde
   */
  private configurarTalonarioPresupuesto() {
    const urlActual = this.router.url;
    
    // 1. Verificar si la ruta es comprobante/compras/create/pedido -> Orden de Compra X
    const esPedidoCompras = urlActual.includes('comprobante/compras/create/pedido') ||
                           (this.type === 'compras' && this.typeComprobante === 'pedido');
    
    if (esPedidoCompras) {
      // Buscar talonario "Orden de Compra X"
      const talonarioOrdenCompra = this.talariosFiltrados.find(talonario => {
        const descripcion = (talonario.description || '').toLowerCase();
        
        // Buscar específicamente "Orden de Compra X"
        const esOrdenCompraX = descripcion.includes('orden de compra x') ||
                              (descripcion.includes('orden') && descripcion.includes('compra') && descripcion.includes('x'));
        
        // Verificar que sea para compras
        const esCompra = (talonario as any).receiptBookType?.value === 'purchases' || 
                        talonario.operation === 'compra' ||
                        talonario.voucherType?.operationType === 'compra';
        
        return esOrdenCompraX && esCompra;
      });

      if (talonarioOrdenCompra) {
        this.form.controls.talonario.setValue(talonarioOrdenCompra.id);
        console.log('✅ Talonario Orden de Compra X configurado automáticamente:', talonarioOrdenCompra.description);
        console.log('📊 currentNumber del talonario:', talonarioOrdenCompra.currentNumber);
        
        // Actualizar explícitamente el número basado en currentNumber del talonario
        this.onTalonarioChange(talonarioOrdenCompra.id);
      } else {
        console.warn('⚠️ No se encontró talonario Orden de Compra X para compras disponible');
        // Intentar buscar cualquier talonario de pedido de compra como fallback
        const talonarioPedidoCompra = this.talariosFiltrados.find(talonario => {
          const descripcion = (talonario.description || '').toLowerCase();
          const esPedido = descripcion.includes('pedido') || descripcion.includes('orden');
          const esCompra = (talonario as any).receiptBookType?.value === 'purchases' || 
                          talonario.operation === 'compra';
          return esPedido && esCompra;
        });
        
        if (talonarioPedidoCompra) {
          this.form.controls.talonario.setValue(talonarioPedidoCompra.id);
          console.log('✅ Talonario de pedido de compra (fallback) configurado:', talonarioPedidoCompra.description);
          console.log('📊 currentNumber del talonario:', talonarioPedidoCompra.currentNumber);
          
          // Actualizar explícitamente el número basado en currentNumber del talonario
          this.onTalonarioChange(talonarioPedidoCompra.id);
        }
      }
      return; // Salir después de configurar pedido de compras
    }
    
    // 2. Verificar si la ruta es comprobante/ventas/create/presupuesto
    const esPresupuestoVentas = urlActual.includes('comprobante/ventas/create/presupuesto') ||
                               (this.type === 'ventas' && this.typeComprobante === 'presupuesto');

    if (esPresupuestoVentas) {
      // Buscar talonario de presupuesto para ventas
      const talonarioPresupuesto = this.talariosFiltrados.find(talonario => {
        // Buscar por nombre/descripción que contenga "presupuesto"
        const descripcion = (talonario.description || '').toLowerCase();
        const esPresupuesto = descripcion.includes('presupuesto') || 
                             descripcion.includes('budget') || 
                             descripcion.includes('quotation');
        
        // Verificar que sea para ventas
        const esVenta = (talonario as any).receiptBookType?.value === 'sales' || 
                       talonario.operation === 'venta' ||
                       talonario.voucherType?.voucherTypesCode?.name?.toLowerCase().includes('presupuesto');
        
        return esPresupuesto && esVenta;
      });

      if (talonarioPresupuesto) {
        this.form.controls.talonario.setValue(talonarioPresupuesto.id);
        console.log('✅ Talonario de presupuesto configurado automáticamente:', talonarioPresupuesto.description);
        console.log('📊 currentNumber del talonario:', talonarioPresupuesto.currentNumber);
        
        // Actualizar explícitamente el número basado en currentNumber del talonario
        this.onTalonarioChange(talonarioPresupuesto.id);
      } else {
        console.warn('⚠️ No se encontró talonario de presupuesto para ventas disponible');
      }
    }
  }

  setDatosComprobante(datos: Voucher) {
    console.log('setDatosComprobante - Datos recibidos:', datos);
    console.log('setDatosComprobante - Header:', datos.header);
    console.log('setDatosComprobante - ReceiptBook:', datos.header?.receiptBook);
    
    this.form.patchValue(datos);
    
    // Verificar que el cliente existe antes de acceder a sus propiedades
    if (datos.client?.companyName) {
      this.form.controls.cliente.setValue(datos.client.companyName);
      this.cliente = datos.client;
      
      // Habilitar el talonario ya que tenemos un cliente
      this.form.controls.talonario.enable();
    }
    
    // Usar createdAt como fecha principal del comprobante
    if (datos.createdAt) {
      // Especificar el formato para dayjs - puede venir en formato ISO o DD/MM/YYYY
      const fechaCreacion = dayjs(datos.createdAt).isValid() 
        ? dayjs(datos.createdAt).toDate()
        : dayjs(datos.createdAt, 'DD/MM/YYYY').toDate();
      
      this.fecha.setValue(fechaCreacion);
      this.fechaDesde.setValue(fechaCreacion);
    }
    
    // Verificar que el header existe antes de acceder a sus propiedades
    if (datos.header) {
      // Si hay dateTo en el header, usarlo para fechaHasta
      if (datos.header.dateTo) {
        // Especificar el formato DD/MM/YYYY para dayjs
        this.fechaHasta.setValue(dayjs(datos.header.dateTo, 'DD/MM/YYYY').toDate());
      } else if (datos.createdAt) {
        // Si no hay dateTo, usar createdAt también para fechaHasta
        const fechaCreacion = dayjs(datos.createdAt).isValid() 
          ? dayjs(datos.createdAt).toDate()
          : dayjs(datos.createdAt, 'DD/MM/YYYY').toDate();
        this.fechaHasta.setValue(fechaCreacion);
      }
      
      // Establecer el talonario basado en el receiptBookId del header o el objeto receiptBook
      if (datos.header.receiptBookId) {
        this.form.controls.talonario.setValue(datos.header.receiptBookId);
        console.log('Talonario seteado desde receiptBookId:', datos.header.receiptBookId);
      } else if (datos.header.receiptBook && datos.header.receiptBook.id) {
        // Si viene como objeto receiptBook, usar su id
        this.form.controls.talonario.setValue(datos.header.receiptBook.id);
        console.log('Talonario seteado desde receiptBook.id:', datos.header.receiptBook.id);
      } else {
        console.log('No se pudo setear el talonario. receiptBookId:', datos.header.receiptBookId, 'receiptBook:', datos.header.receiptBook);
      }
      
      // Si es una operación de compra, cargar los valores de punto de venta y número en los campos manuales
      if (this.esOperacionCompra()) {
        if (datos.header.salesPointsId) {
          this.form.controls.puntoVentaManual.setValue(datos.header.salesPointsId);
          console.log('Punto de venta manual seteado:', datos.header.salesPointsId);
        }
        if (datos.header.number) {
          this.form.controls.numeroComprobanteManual.setValue(datos.header.number);
          console.log('Número de comprobante manual seteado:', datos.header.number);
        }
      }
    } else if (datos.createdAt) {
      // Si no hay header pero sí createdAt, usar createdAt para fechaHasta también
      const fechaCreacion = dayjs(datos.createdAt).isValid() 
        ? dayjs(datos.createdAt).toDate()
        : dayjs(datos.createdAt, 'DD/MM/YYYY').toDate();
      this.fechaHasta.setValue(fechaCreacion);
    }
    
    // Configurar tipo de comprobante para el título
    this.typeComprobanteDB = this.obtenerTipoComprobanteDB();
    
    // Verificar que detail existe antes de procesarlo
    if (datos.detail) {
      this.cajaService.articulosList = Array.isArray(datos.detail)
        ? datos.detail
        : [datos.detail];
      
      // Procesar cada artículo para establecer las unidades de medida correctamente
      this.procesarArticulosParaEdicion();
    }
    
    this.subtotal = datos.netAmount || 0;
    this.total = datos.totalAmount || 0;
    
    // Calcular neto gravado (asumiendo que netAmount ya incluye bonificaciones aplicadas)
    this.netoGravado = this.subtotal;
    
    // Si hay datos de IVA en el comprobante, usarlos
    if (datos.iva && Array.isArray(datos.iva) && datos.iva.length > 0) {
      this.desgloseIva = datos.iva.map(ivaItem => ({
        percentage: this.extraerPorcentajeDeNombre(ivaItem.name || ''),
        baseAmount: Number(ivaItem.baseImp || 0),
        amount: Number(ivaItem.importe || 0)
      }));
      this.totalIva = this.desgloseIva.reduce((sum, iva) => sum + iva.amount, 0);
    } else {
      // Si no hay datos específicos de IVA, calcularlo desde el formulario
      this.calcularDesgloseIVA();
    }
    
    // Calcular otros impuestos basado en la diferencia
    // Total = NetAmount + IVA + OtrosImpuestos
    const calculatedImpuestos = (datos.totalAmount || 0) - (this.netoGravado + this.totalIva);
    this.impuestos = calculatedImpuestos > 0 ? calculatedImpuestos : 0;
    
    // Inicializar tributos si hay impuestos calculados
    this.inicializarTributosDesdeImpuestos();
    
    if (datos.conceptId) {
      this.form.controls.concepto.setValue(datos.conceptId);
    }
    
    // Cargar datos de CAE si existen
    if (datos.cae) {
      this.form.controls.cae.setValue(datos.cae);
    }
    
    // Cargar comentario si existe
    if (datos.comment) {
      this.form.controls.comentario.setValue(datos.comment);
    }

    if (datos.expirationDateCae) {
      // Convertir la fecha de vencimiento CAE al formato adecuado
      const fechaVencimientoCae = dayjs(datos.expirationDateCae).isValid() 
        ? dayjs(datos.expirationDateCae).toDate()
        : dayjs(datos.expirationDateCae, 'DD/MM/YYYY').toDate();
      this.form.controls.fechaVencimientoCae.setValue(fechaVencimientoCae);
    }
  }

  /**
   * Actualiza el sidebar con la información del comprobante actual
   */
  actualizarSidebarConDatos(datos: Voucher) {
    if (this.sidebar !== undefined && datos?.header) {
      // Obtener información del talonario para el punto de venta
      let puntoVenta = '0001'; // Valor por defecto
      let tipoComprobante = this.typeComprobante || 'Comprobante';
      
      if (datos.header.receiptBook) {
        // Buscar el talonario completo en la lista cargada para obtener el punto de venta
        const talonarioCompleto = this.talonarios.find(t => t.id === datos.header.receiptBook.id);
        if (talonarioCompleto && talonarioCompleto.salesPoint) {
          puntoVenta = this.dataService.formatearPuntoVenta(talonarioCompleto.salesPoint.number);
        }
        
        // Usar la descripción del talonario como tipo si está disponible
        if (datos.header.receiptBook.description) {
          tipoComprobante = datos.header.receiptBook.description;
        }
      }
      
      const nro = this.dataService.formatearNumeroComprobante(datos.header.number || 0);
      this.sidebar.innerHTML = `${tipoComprobante}: ${puntoVenta} - ${nro}`;
      console.log('Sidebar actualizado con datos cargados:', `${tipoComprobante}: ${puntoVenta} - ${nro}`);
    }
  }

  getNumeroComprobante() {
    // Solo obtener número si hay un talonario seleccionado
    const talonarioId = this.form.controls.talonario.value;
    if (!talonarioId && this.talariosFiltrados.length > 0) {
      // Si no hay talonario seleccionado pero hay talonarios disponibles, 
      // seleccionar el primero automáticamente
      this.form.controls.talonario.setValue(this.talariosFiltrados[0].id);
      return;
    }

    const talonarioSeleccionado = this.talariosFiltrados.find(t => t.id === talonarioId);
    if (!talonarioSeleccionado) {
      console.warn('❌ No se encontró el talonario seleccionado');
      return;
    }

    // Usar directamente el currentNumber del talonario del listado
    const puntoVenta = talonarioSeleccionado.salesPointsId || 1;
    const numeroActual = talonarioSeleccionado.currentNumber || 1;
    const nombreTalonario = talonarioSeleccionado.description || `Talonario ${talonarioSeleccionado.id}`;
    
    // Establecer los valores del componente
    this.punto = puntoVenta;
    this.nro = numeroActual;
    
    // Actualizar el sidebar con el formato correcto
    if (this.sidebar !== undefined) {
      const punto = this.dataService.formatearPuntoVenta(puntoVenta);
      const nro = this.dataService.formatearNumeroComprobante(numeroActual);
      this.sidebar.innerHTML = `${nombreTalonario} ${punto}-${nro}`;
      
      console.log('✅ Número obtenido del talonario del listado:');
      console.log(`   📋 Talonario: ${nombreTalonario}`);
      console.log(`   📍 Punto de Venta: ${puntoVenta} (${punto})`);
      console.log(`   🔢 Número Actual: ${numeroActual} (${nro})`);
      console.log(`   💾 currentNumber del talonario: ${talonarioSeleccionado.currentNumber}`);
    }
  }

  openDialogClientes() {
    const dialogRef = this.dialog.open(ListaClienteComponent, {
      width: '80%',
      minHeight: '80%',
      data: {
        type: this.typeCliente,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.cliente = result;
        this.form.controls.cliente.setValue(this.cliente.companyName, {
          onlySelf: true,
        });
        
        // Habilitar el talonario cuando se selecciona un cliente
        this.form.controls.talonario.enable();

        // Re-filtrar talonarios según la condición fiscal del nuevo cliente
        console.log(`🔄 Cliente cambiado: ${this.cliente.companyName} (${this.getTipoResponsableFiscal()})`);
        this.filtrarTalonarios();
        
        // Verificar si el talonario actual sigue siendo válido después del filtrado fiscal
        const talonarioSeleccionadoActual = this.form.get('talonario')?.value;
        const talonarioSigueValido = talonarioSeleccionadoActual && 
                                   this.talariosFiltrados.find(t => t.id === talonarioSeleccionadoActual);
        
        if (talonarioSeleccionadoActual && !talonarioSigueValido) {
          console.log('⚠️ Talonario actual no compatible con nuevo cliente - limpiando selección');
          this.form.controls.talonario.setValue('');
        }
        
        // Seleccionar automáticamente el talonario más apropiado para el nuevo cliente
        if (!talonarioSigueValido) {
          console.log('🎯 Seleccionando talonario automático para nuevo cliente');
          this.seleccionarTalonarioAutomatico();
        }
        
        // Verificar si debe preservar el talonario actual (solo si es válido)
        const debePreservarTalonario = talonarioSigueValido && 
                                     this.debePreservarTalonarioActual(talonarioSeleccionadoActual);
        
        if (!debePreservarTalonario && !talonarioSigueValido) {
          console.log('✅ Talonario actualizado según normativa fiscal');
        }
      }
    });
  }

  salir() {
    if (this.type === 'ventas') {
      this.router.navigate(['/ventas']);
    } else {
      this.router.navigate(['/compras']);
    }
  }

  verListaArticulos() {
    // Validar que se haya seleccionado un talonario
    const talonarioId = this.form.controls.talonario.value;
    if (!talonarioId) {
      this.openSnackBar('Debe seleccionar un talonario antes de agregar artículos', 'Advertencia');
      return;
    }

    // Validar que se haya seleccionado una lista de precios correctamente (acepta 0, string, number, etc)
    const priceListId = this.form.controls.priceListId.value;
    if (priceListId === null || priceListId === undefined || priceListId === '') {
      this.openSnackBar('Debe seleccionar una lista de precios antes de agregar artículos', 'Advertencia');
      return;
    }

    const dialogRef = this.dialog.open(ListaProductosDialogoComponent, {
      minWidth: '60%',
      maxHeight: '85%',
      minHeight: '300px',
      data: {
        type: 'articulo',
        bonificacion: this.cliente?.bonificacionValue,
        priceListId: priceListId, // Pasar la lista de precios seleccionada
        typeComprobante: this.typeComprobante, // Pasar el tipo de comprobante
        tipoOperacion: this.type, // Pasar si es ventas o compras
        permitirSinStock: this.typeComprobante === 'presupuesto' || this.esOperacionCompra(), // Permitir artículos sin stock para presupuestos y todos los comprobantes de compra
      },
      disableClose: true,
      autoFocus: true,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Establecer la primera unidad por defecto para cada producto agregado
        this.setDefaultUnitToNewProducts();
        // Si hay artículos nuevos y una lista de precios seleccionada, aplicar los precios
        const priceListId = this.form.controls.priceListId.value;
        if (priceListId !== null && priceListId !== undefined && priceListId !== '') {
          this.actualizarPreciosArticulos(priceListId);
        }
        this.sumarTotalProductos();
      }
    });
  }

  /**
   * Establece la primera unidad de conversión como predeterminada para los productos recién añadidos
   * y asegura que las propiedades de bonificación estén inicializadas correctamente
   * Incluye soporte para unidades compuestas
   */
  setDefaultUnitToNewProducts() {
    this.cajaService.articulosList.forEach(product => {
      // Para productos regulares (no detalles libres)
      if (product.type !== 'detalle_libre') {
        // Asegurar que el producto tenga unidades de conversión
        this.asegurarUnidadesConversion(product);
        
        // Si el producto tiene unidades de conversión y no tiene una unidad seleccionada
        if (
          product.conversionUnits &&
          product.conversionUnits.length > 0 &&
          !product.conversionUnitId
        ) {
          // Establecer la primera unidad como predeterminada
          product.conversionUnitId = product.conversionUnits[0].id;
        }
      }
      
      // Asegurar que las propiedades de bonificación estén inicializadas
      if (product.bonus === undefined || product.bonus === null) {
        product.bonus = 0;
      }
      if (product.bonusAmount === undefined || product.bonusAmount === null) {
        product.bonusAmount = 0;
      }
    });
  }

  /**
   * Determina si el comprobante actual es un remito de compra
   * Se mantiene para lógicas específicas de remitos (como no mostrar totales, etc.)
   */
  esRemitoDeCompra(): boolean {
    return this.type === 'compras' && this.typeComprobante === 'remito';
  }

  /**
   * Determina si el comprobante actual es un pedido de compra (Orden de Compra)
   */
  esPedidoDeCompra(): boolean {
    return this.type === 'compras' && this.typeComprobante === 'pedido';
  }

  /**
   * Determina si es una operación de compra
   */
  esOperacionCompra(): boolean {
    return this.type === 'compras';
  }

  /**
   * Determina si el comprobante actual es una Factura A
   * Según normativa fiscal argentina:
   * - Factura A: Se emite SOLO de Responsable Inscripto (RI) a otro Responsable Inscripto (RI)
   * - Factura B: Se emite de RI a Consumidores Finales, Monotributistas o Exentos
   * Solo las Facturas A requieren desglose de IVA discriminado
   */
  esFacturaA(): boolean {
    // Verificar si es una factura
    if (this.typeComprobante !== 'factura') {
      return false;
    }

    // Verificar que tenemos cliente seleccionado
    if (!this.cliente) {
      return false;
    }

    // Verificar la condición fiscal del cliente
    // responsibleTypeId: 2 = Responsable Inscripto (según comentario en detalle-producto.component.ts)
    // Solo se emite Factura A si el cliente es Responsable Inscripto
    const esClienteResponsableInscripto = this.cliente.responsibleTypeId === 2;
    
    if (!esClienteResponsableInscripto) {
      // Si el cliente NO es RI, nunca debe ser Factura A
      // (sería un error fiscal emitir Factura A a Consumidor Final/Monotributista/Exento)
      return false;
    }

    // Si el cliente ES Responsable Inscripto, verificar el talonario
    const talonarioId = this.form.get('talonario')?.value;
    if (talonarioId) {
      const talonarioSeleccionado = this.talariosFiltrados.find(t => t.id === talonarioId);
      if (talonarioSeleccionado?.receiptBookLetter?.letter) {
        return talonarioSeleccionado.receiptBookLetter.letter.toUpperCase() === 'A';
      }
    }

    // Fallback: verificar por typeComprobanteDB si tiene información de letra
    if (this.typeComprobanteDB?.voucherTypesCode?.name) {
      const nombre = this.typeComprobanteDB.voucherTypesCode.name.toUpperCase();
      return nombre.includes('FACTURA A') || nombre.includes('FACTURA') && nombre.includes(' A');
    }

    // Si no se puede determinar el tipo de talonario, asumir Factura B por seguridad fiscal
    return false;
  }

  /**
   * Obtiene el tipo de responsable fiscal del cliente actual
   */
  getTipoResponsableFiscal(): string {
    if (!this.cliente || !this.cliente.responsibleTypeId) {
      return 'No determinado';
    }

    switch (this.cliente.responsibleTypeId) {
      case 1:
        return 'Consumidor Final';
      case 2:
        return 'Responsable Inscripto';
      case 3:
        return 'Monotributista';
      case 4:
        return 'Exento';
      default:
        return 'Tipo no reconocido';
    }
  }

  /**
   * Obtiene el tipo de factura recomendado según el cliente
   */
  getTipoFacturaRecomendado(): string {
    if (!this.cliente || !this.cliente.responsibleTypeId) {
      return 'No determinado';
    }

    switch (this.cliente.responsibleTypeId) {
      case 1: // Consumidor Final
        return 'Factura C';
      case 2: // Responsable Inscripto
        return 'Factura A (discrimina IVA)';
      case 3: // Monotributista
      case 4: // Exento
        return 'Factura B';
      default:
        return 'Consultar normativa fiscal';
    }
  }

  /**
   * Determina si debe mostrar advertencia sobre tipo de factura según normativa fiscal
   */
  debeMostrarAdvertenciaFiscal(): boolean {
    return this.typeComprobante === 'factura' && this.cliente && 
           this.form.get('talonario')?.value;
  }

  /**
   * Obtiene el mensaje de advertencia fiscal según el tipo de cliente y factura
   */
  getMensajeAdvertenciaFiscal(): string {
    if (!this.cliente) return '';

    const tipoResponsable = this.getTipoResponsableFiscal();
    const tipoRecomendado = this.getTipoFacturaRecomendado();
    const talonarioActual = this.form.get('talonario')?.value;
    
    if (!talonarioActual) {
      return `Cliente: ${tipoResponsable} - Recomendado: ${tipoRecomendado}`;
    }

    const talonarioSeleccionado = this.talariosFiltrados.find(t => t.id === talonarioActual);
    const letraFactura = talonarioSeleccionado?.receiptBookLetter?.letter?.toUpperCase() || '?';
    
    const esFactA = this.esFacturaA();
    
    if (esFactA) {
      return `✓ Factura ${letraFactura} - ${tipoResponsable} - Desglose de IVA habilitado (Normativa AFIP)`;
    } else {
      const tipoIva = letraFactura === 'C' ? 'No discrimina IVA' : 'IVA incluido en precio final';
      return `✓ Factura ${letraFactura} - ${tipoResponsable} - ${tipoIva}`;
    }
  }

  /**
   * Aplica filtrado fiscal según normativa argentina para facturas
   * Factura A: Solo para RI → RI
   * Factura B: Para RI → (Consumidor Final, Monotributista, Exento)
   * Factura C: Entre no-RI
   */
  private aplicarFiltradoFiscal(talonarios: ReceiptBook[]): ReceiptBook[] {
    if (!this.cliente) {
      console.log('⚠️ Sin cliente seleccionado - mostrando todos los talonarios');
      return talonarios;
    }

    const esClienteRI = this.cliente.responsibleTypeId === 2; // Responsable Inscripto
    const tipoResponsable = this.getTipoResponsableFiscal();
    
    console.log(`👤 Cliente: ${tipoResponsable} (ID: ${this.cliente.responsibleTypeId})`);

    const talonariosFiltrados = talonarios.filter(talonario => {
      const esFacturaA = talonario.receiptBookLetter?.letter?.toUpperCase() === 'A';
      
      if (esFacturaA && !esClienteRI) {
        // PROHIBIR Factura A para no-RI (error fiscal)
        console.log(`❌ Ocultando ${talonario.description} (Factura A) - Cliente no es RI`);
        return false;
      }
      
      // Permitir todas las demás combinaciones
      console.log(`✅ Habilitando ${talonario.description} para cliente ${tipoResponsable}`);
      return true;
    });

    if (talonariosFiltrados.length === 0) {
      console.warn('⚠️ Filtrado fiscal resultó en 0 talonarios - mostrando todos por seguridad');
      return talonarios;
    }

    console.log(`📋 Filtrado fiscal: ${talonariosFiltrados.length}/${talonarios.length} talonarios habilitados`);
    return talonariosFiltrados;
  }

  /**
   * Selecciona automáticamente el talonario más apropiadosegún el tipo de cliente
   * Consumidor Final → Factura C (prioritaria)
   * Responsable Inscripto → Factura A (prioritaria) o B
   * Monotributista/Exento → Factura B o C
   */
  private seleccionarTalonarioAutomatico(): void {
    if (!this.cliente || this.talariosFiltrados.length === 0) {
      console.log('⚠️ No se puede seleccionar talonario automático - falta cliente o talonarios');
      return;
    }

    const tipoResponsable = this.getTipoResponsableFiscal();
    let talonarioPreferido: ReceiptBook | undefined;

    // Prioridades según tipo de cliente
    if (this.cliente.responsibleTypeId === 1) { // Consumidor Final
      // Para Consumidor Final, priorizar Factura C
      talonarioPreferido = this.talariosFiltrados.find(t => 
        t.receiptBookLetter?.letter?.toUpperCase() === 'C'
      );
      console.log(`🎯 Consumidor Final - buscando Factura C`);
    } else if (this.cliente.responsibleTypeId === 2) { // Responsable Inscripto
      // Para RI, priorizar Factura A (para discriminar IVA)
      talonarioPreferido = this.talariosFiltrados.find(t => 
        t.receiptBookLetter?.letter?.toUpperCase() === 'A'
      );
      console.log(`🎯 Responsable Inscripto - buscando Factura A`);
    } else { // Monotributista, Exento, otros
      // Para otros, priorizar Factura B
      talonarioPreferido = this.talariosFiltrados.find(t => 
        t.receiptBookLetter?.letter?.toUpperCase() === 'B'
      );
      console.log(`🎯 ${tipoResponsable} - buscando Factura B`);
    }

    // Si no encuentra el preferido, tomar el primero disponible
    if (!talonarioPreferido && this.talariosFiltrados.length > 0) {
      talonarioPreferido = this.talariosFiltrados[0];
      console.log(`⚠️ Talonario preferido no encontrado - usando: ${talonarioPreferido.description}`);
    }

    // Seleccionar el talonario encontrado
    if (talonarioPreferido) {
      this.form.controls.talonario.setValue(talonarioPreferido.id);
      console.log(`✅ Talonario seleccionado automáticamente: ${talonarioPreferido.description} para ${tipoResponsable}`);
      
      // Configurar título y obtener número
      this.configurarTituloSegunTipo();
      this.onTalonarioChange(talonarioPreferido.id);
      
      setTimeout(() => {
        this.getNumeroComprobante();
      }, 100);
    } else {
      console.warn(`❌ No se pudo seleccionar talonario automático para ${tipoResponsable}`);
    }
  }

  /**
   * Actualiza el título del sidebar cuando cambian los campos manuales de compra
   */
  actualizarTituloCompra() {
    if (!this.esOperacionCompra() || this.sidebar === undefined) {
      return;
    }

    const talonarioId = this.form.controls.talonario.value;
    const talonarioSeleccionado = this.talariosFiltrados.find(t => t.id === talonarioId);
    
    if (!talonarioSeleccionado) {
      console.warn('❌ No se encontró el talonario seleccionado para actualizar título');
      return;
    }

    // Obtener valores de los campos manuales o usar los del talonario como fallback
    const puntoVentaManual = this.form.controls.puntoVentaManual.value;
    const numeroManual = this.form.controls.numeroComprobanteManual.value;
    
    const puntoVenta = puntoVentaManual || talonarioSeleccionado.salesPointsId || 1;
    const numeroActual = numeroManual || talonarioSeleccionado.currentNumber || 1;
    
    // Actualizar propiedades del componente
    this.punto = puntoVenta;
    this.nro = numeroActual;
    
    // Actualizar la visualización en el sidebar
    const nombreTalonario = talonarioSeleccionado.description || `Talonario ${talonarioSeleccionado.id}`;
    const punto = this.dataService.formatearPuntoVenta(puntoVenta);
    const nro = this.dataService.formatearNumeroComprobante(numeroActual);
    this.sidebar.innerHTML = `${nombreTalonario} ${punto}-${nro}`;
    
    console.log('📋 Título actualizado (compra manual):', this.sidebar.innerHTML);
    console.log('   📍 Punto de Venta:', puntoVenta, `(${punto})`);
    console.log('   🔢 Número:', numeroActual, `(${nro})`);
  }

  /**
   * Abre el diálogo de productos filtrados por proveedor para comprobantes de compras
   */
  verListaArticulosProveedor() {
    // Validar que sea un comprobante de compras
    if (this.type !== 'compras') {
      this.openSnackBar('Esta función solo está disponible para comprobantes de compras', 'Error');
      return;
    }

    // Validar que se haya seleccionado un proveedor
    if (!this.cliente || !this.cliente.id) {
      this.openSnackBar('Debe seleccionar un proveedor antes de agregar artículos', 'Advertencia');
      return;
    }

    // Validar que se haya seleccionado un talonario
    const talonarioId = this.form.controls.talonario.value;
    if (!talonarioId) {
      this.openSnackBar('Debe seleccionar un talonario antes de agregar artículos', 'Advertencia');
      return;
    }

    // Validar que se haya seleccionado una lista de precios
    const priceListId = this.form.controls.priceListId.value;
    if (priceListId === null || priceListId === undefined || priceListId === '') {
      this.openSnackBar('Debe seleccionar una lista de precios antes de agregar artículos', 'Advertencia');
      return;
    }

    const dialogRef = this.dialog.open(ListaProductosDialogoComponent, {
      minWidth: '60%',
      maxHeight: '85%',
      minHeight: '300px',
      data: {
        type: 'articulo-proveedor',
        bonificacion: this.cliente?.bonificacionValue,
        priceListId: priceListId,
        supplierId: this.cliente.id, // Pasar el ID del proveedor para filtrar
        typeComprobante: this.typeComprobante, // Pasar el tipo de comprobante
        tipoOperacion: this.type, // Pasar si es ventas o compras
        permitirSinStock: this.typeComprobante === 'presupuesto' || this.esOperacionCompra(), // Permitir artículos sin stock para presupuestos y todos los comprobantes de compra
      },
      disableClose: true,
      autoFocus: true,
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Establecer la primera unidad por defecto para cada producto agregado
        this.setDefaultUnitToNewProducts();
        // Si hay artículos nuevos y una lista de precios seleccionada, aplicar los precios
        if (priceListId !== null && priceListId !== undefined && priceListId !== '') {
          this.actualizarPreciosArticulos(priceListId);
        }
        this.sumarTotalProductos();
      }
    });
  }

  procesarArticulosParaEdicion() {
    this.cajaService.articulosList.forEach((articulo, index) => {
      // Para artículos regulares (no detalles libres)
      if (articulo.type !== 'detalle_libre') {
        // Debug: Verificar estructura del artículo
        console.log('Procesando artículo:', {
          description: articulo.description,
          measurementUnitId: articulo.measurementUnitId,
          conversionUnits: articulo.conversionUnits,
          articuloCompleto: articulo
        });
        
        // SIEMPRE asegurar que el artículo tenga unidades de conversión
        this.asegurarUnidadesConversion(articulo);
        
        // Establecer la unidad seleccionada correctamente
        this.establecerUnidadSeleccionada(articulo);
        
        // Debug: Verificar resultado
        console.log('Después del procesamiento:', {
          description: articulo.description,
          conversionUnitId: articulo.conversionUnitId,
          conversionUnits: articulo.conversionUnits
        });
      }
    });
    
    // Recalcular totales después de procesar los artículos
    setTimeout(() => {
      this.sumarTotalProductos();
    }, 100);
  }

  /**
   * Asegura que el artículo tenga unidades de conversión disponibles
   * Incluye tanto unidades básicas como compuestas
   */
  private asegurarUnidadesConversion(articulo: any) {
    console.log('asegurarUnidadesConversion para:', {
      code: articulo.code,
      description: articulo.description,
      conversionUnits: articulo.conversionUnits?.length || 0,
      conversionUnitId: articulo.conversionUnitId,
      measurementUnitId: articulo.measurementUnitId,
      'article.measurementUnitId': articulo.article?.measurementUnitId,
      measurementUnit: articulo.measurementUnit,
      'article.measurementUnit': articulo.article?.measurementUnit
    });
    
    // Si no tiene conversionUnits o están vacías, crear las unidades básicas
    if (!articulo.conversionUnits || articulo.conversionUnits.length === 0) {
      articulo.conversionUnits = [];
      
      // Obtener la unidad de medida desde diferentes posibles ubicaciones
      let measurementUnitId = articulo.measurementUnitId;
      let measurementUnit = articulo.measurementUnit;
      
      // Si no está en el nivel superior, buscar en el objeto article anidado
      if (!measurementUnitId && articulo.article) {
        measurementUnitId = articulo.article.measurementUnitId;
        measurementUnit = articulo.article.measurementUnit;
        console.log('Obteniendo datos del article anidado:', { measurementUnitId, measurementUnit });
        
        // IMPORTANTE: Copiar los datos del article anidado al nivel superior para consistencia
        if (measurementUnitId) {
          articulo.measurementUnitId = measurementUnitId;
        }
        if (measurementUnit) {
          articulo.measurementUnit = measurementUnit;
        }
      }
      
      // Crear unidad básica principal si existe measurementUnitId
      if (measurementUnitId && measurementUnit) {
        const unidadBasica = {
          id: measurementUnitId,
          measurementUnitId: measurementUnitId,
          baseMeasurementUnitId: measurementUnitId,
          quantity: 1,
          price: articulo.unitPrice || articulo.price || 0,
          measurementUnit: measurementUnit,
          baseMeasurementUnit: measurementUnit,
          article: null
        };
        articulo.conversionUnits.push(unidadBasica);
        
        // Establecer el ID de la unidad de conversión seleccionada
        articulo.conversionUnitId = measurementUnitId;
        
        console.log('Creada unidad básica:', unidadBasica);
      } else if (measurementUnitId && this.medidas && this.medidas.length > 0) {
        // Fallback: buscar en la lista de medidas disponibles
        const unidadMedida = this.medidas.find(u => u.id === measurementUnitId);
        if (unidadMedida) {
          const unidadBasica = {
            id: measurementUnitId,
            measurementUnitId: measurementUnitId,
            baseMeasurementUnitId: measurementUnitId,
            quantity: 1,
            price: articulo.unitPrice || articulo.price || 0,
            measurementUnit: unidadMedida,
            baseMeasurementUnit: unidadMedida,
            article: null
          };
          articulo.conversionUnits.push(unidadBasica);
          articulo.conversionUnitId = measurementUnitId;
        }
      }
      
      // Crear unidad secundaria si existe secondaryMeasurementUnitId
      let secondaryMeasurementUnitId = articulo.secondaryMeasurementUnitId;
      if (!secondaryMeasurementUnitId && articulo.article) {
        secondaryMeasurementUnitId = articulo.article.secondaryMeasurementUnitId;
      }
      
      if (secondaryMeasurementUnitId && this.medidas && this.medidas.length > 0) {
        const unidadSecundaria = this.medidas.find(u => u.id === secondaryMeasurementUnitId);
        if (unidadSecundaria && secondaryMeasurementUnitId !== measurementUnitId) {
          const unidadCompuesta = {
            id: secondaryMeasurementUnitId,
            measurementUnitId: secondaryMeasurementUnitId,
            baseMeasurementUnitId: measurementUnitId,
            quantity: 1, // Esto debería venir del backend en casos reales
            price: articulo.unitPrice || articulo.price || 0,
            measurementUnit: unidadSecundaria,
            baseMeasurementUnit: measurementUnit || this.medidas.find(u => u.id === measurementUnitId),
            article: null
          };
          articulo.conversionUnits.push(unidadCompuesta);
        }
      }
    }
    
    // IMPORTANTE: Verificar si conversionUnitId es 0 o inválido pero tenemos measurementUnitId
    if (articulo.conversionUnitId === 0 || !articulo.conversionUnitId) {
      if (articulo.measurementUnitId) {
        console.log('conversionUnitId es 0 o inválido, usando measurementUnitId:', articulo.measurementUnitId);
        articulo.conversionUnitId = articulo.measurementUnitId;
      }
    }
  }

  /**
   * Establece la unidad seleccionada correctamente basada en los datos del artículo
   */
  private establecerUnidadSeleccionada(articulo: any) {
    console.log('establecerUnidadSeleccionada para:', {
      code: articulo.code,
      conversionUnitId: articulo.conversionUnitId,
      measurementUnitId: articulo.measurementUnitId,
      conversionUnitsLength: articulo.conversionUnits?.length || 0
    });
    
    if (articulo.conversionUnits && articulo.conversionUnits.length > 0) {
      // Si conversionUnitId es 0 o inválido, usar measurementUnitId
      if (!articulo.conversionUnitId || articulo.conversionUnitId === 0) {
        const measurementUnitId = articulo.measurementUnitId || articulo.article?.measurementUnitId;
        if (measurementUnitId) {
          articulo.conversionUnitId = measurementUnitId;
          console.log('Establecido conversionUnitId desde measurementUnitId:', measurementUnitId);
          return;
        }
      }
      
      // Si ya tiene una unidad seleccionada válida, mantenerla
      if (articulo.conversionUnitId && 
          articulo.conversionUnits.find(cu => cu.id === articulo.conversionUnitId)) {
        console.log('Manteniendo conversionUnitId existente:', articulo.conversionUnitId);
        return;
      }
      
      // Obtener measurementUnitId desde diferentes posibles ubicaciones
      let measurementUnitId = articulo.measurementUnitId;
      if (!measurementUnitId && articulo.article) {
        measurementUnitId = articulo.article.measurementUnitId;
      }
      
      // Buscar la unidad correcta basada en measurementUnitId
      if (measurementUnitId) {
        const conversionUnit = articulo.conversionUnits.find(cu => 
          cu.measurementUnit?.id === measurementUnitId
        );
        if (conversionUnit) {
          articulo.conversionUnitId = conversionUnit.id;
          console.log('Establecido conversionUnitId desde conversionUnits:', conversionUnit.id);
          return;
        }
      }
      
      // Si no encuentra match, usar la primera unidad disponible
      articulo.conversionUnitId = articulo.conversionUnits[0].id;
    } else {
      // Si no hay conversionUnits, establecer el measurementUnitId como conversionUnitId
      let measurementUnitId = articulo.measurementUnitId;
      if (!measurementUnitId && articulo.article) {
        measurementUnitId = articulo.article.measurementUnitId;
      }
      if (measurementUnitId) {
        articulo.conversionUnitId = measurementUnitId;
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  sumarTotalProductos() {
    this.total = 0;
    this.subtotal = 0;
    this.bonificacion = 0;
    this.cajaService.articulosList.forEach(p => {
      // Validar que los valores sean números válidos
      const quantity = Number(p.quantity) || 0;
      const unitPrice = Number(p.unitPrice) || 0;
      const bonus = Number(p.bonus) || 0;
      
      // Manejo diferente según el tipo de artículo
      if (
        p.type !== 'detalle_libre' &&
        p.conversionUnits &&
        p.conversionUnits.length > 0
      ) {
        // Para artículos regulares con unidades de conversión
        const conversionUnit = p.conversionUnits.find(x => x.id === p.conversionUnitId);
        if (conversionUnit) {
          // En modo edición, preservar el precio original del artículo si existe
          // Solo actualizar desde conversionUnit si no hay precio establecido
          if (!unitPrice || unitPrice === 0) {
            p.unitPrice = Number(conversionUnit?.price) || 0;
          } else {
            // Actualizar el precio en la conversionUnit para mantener consistencia
            conversionUnit.price = unitPrice;
          }
        }
      }
      
      // El cálculo es igual para ambos tipos - usando valores validados
      const finalQuantity = Number(p.quantity) || 0;
      const finalUnitPrice = Number(p.unitPrice) || 0;
      const finalBonus = Number(p.bonus) || 0;
      
      const subtotal: number = finalQuantity * finalUnitPrice;
      const bonif = (subtotal * finalBonus) / 100;
      const total: number = subtotal - bonif;
      
      // Validar que los resultados no sean NaN
      if (!isNaN(subtotal)) this.subtotal += subtotal;
      if (!isNaN(bonif)) this.bonificacion += bonif;
      if (!isNaN(total)) this.total += total;
    });

    // Asegurar que los totales no sean NaN
    this.subtotal = Number(this.subtotal.toFixed(2));
    this.bonificacion = Number(this.bonificacion.toFixed(2));
    this.total = Number(this.total.toFixed(2));

    // Calcular neto gravado (subtotal - bonificación)
    this.netoGravado = Number((this.subtotal - this.bonificacion).toFixed(2));

    // Calcular y estructurar el desglose de IVA (solo para Facturas A)
    this.calcularDesgloseIVA();

    // Recalcular tributos con porcentaje basado en el nuevo subtotal
    this.recalcularTributosConPorcentaje();
    
    // Calcular total final
    const impuestosValidos = Number(this.impuestos) || 0;
    this.totalIva = this.desgloseIva.reduce((sum, iva) => sum + iva.amount, 0);
    
    if (this.esFacturaA()) {
      // Para Facturas A: Neto Gravado + IVA + Otros Impuestos
      this.total = Number((this.netoGravado + this.totalIva + impuestosValidos).toFixed(2));
    } else {
      // Para otros comprobantes: Total tradicional (subtotal - bonificación + impuestos)
      this.total = Number((this.total + impuestosValidos).toFixed(2));
    }
  }

  /**
   * Extrae el porcentaje de IVA del nombre (ej: "IVA 21%" -> 21)
   * @param nombre Nombre del tipo de IVA
   * @returns El porcentaje como número
   */
  extraerPorcentajeDeNombre(nombre: string): number {
    if (!nombre) return 0;
    const match = nombre.match(/(\d+(?:\.\d+)?)/);
    return match ? parseFloat(match[1]) : 0;
  }

  /**
   * Calcula el desglose de IVA para mostrar en la interfaz
   * Actualiza las propiedades desgloseIva y totalIva del componente
   * SOLO se muestra para Facturas A según normativa argentina
   */
  calcularDesgloseIVA(): void {
    const ivaMap = new Map<number, { percentage: number; baseAmount: number; amount: number }>();
    this.desgloseIva = [];
    this.totalIva = 0;

    // SOLO calcular desglose para Facturas A
    if (!this.esFacturaA()) {
      return;
    }

    // Obtener el tipo de IVA seleccionado en el formulario
    const ivaFormulario = this.form.get('iva')?.value;
    const ivaRate = this.typeivas.find(iva => iva.id === ivaFormulario);
    
    // Extraer porcentaje del nombre del IVA (ej: "21%" -> 21)
    let ivaPercentage = 0;
    if (ivaRate?.name) {
      const match = ivaRate.name.match(/(\d+(?:\.\d+)?)/);
      ivaPercentage = match ? parseFloat(match[1]) : 0;
    }

    // Solo calcular IVA si hay un porcentaje válido y no es un pedido de compra
    if (ivaPercentage > 0 && !this.esPedidoDeCompra()) {
      // Aplicar IVA al neto gravado
      const ivaAmount = (this.netoGravado * ivaPercentage) / 100;
      
      if (ivaAmount > 0) {
        this.desgloseIva.push({
          percentage: ivaPercentage,
          baseAmount: this.netoGravado,
          amount: Number(ivaAmount.toFixed(2))
        });
        
        this.totalIva = Number(ivaAmount.toFixed(2));
      }
    }
  }

  /**
   * Calcula y estructura el IVA de los productos para el comprobante
   * @returns Objeto con el total de IVA y array estructurado
   */
  calcularIvaProductos(): { totalIva: number; ivaArray: any[] } {
    const ivaMap = new Map<number, { percentage: number; baseAmount: number; amount: number }>();
    let totalIva = 0;

    // Por ahora, usamos el IVA del formulario general aplicado a todos los productos
    // TODO: Implementar IVA individual por producto cuando esté disponible en el modelo
    const ivaFormulario = this.form.get('iva')?.value;
    const ivaRate = this.typeivas.find(iva => iva.id === ivaFormulario);
    
    // Extraer porcentaje del nombre del IVA (ej: "21%" -> 21)
    let ivaPercentage = 0;
    if (ivaRate?.name) {
      const match = ivaRate.name.match(/(\d+(?:\.\d+)?)/);
      ivaPercentage = match ? parseFloat(match[1]) : 0;
    }

    if (ivaPercentage > 0) {
      this.cajaService.articulosList.forEach(producto => {
        // Solo procesar productos que no sean detalles libres
        if (producto.type !== 'detalle_libre') {
          const quantity = Number(producto.quantity) || 0;
          const unitPrice = Number(producto.unitPrice) || 0;
          const bonus = Number(producto.bonus) || 0;
          
          const subtotalProducto = (quantity * unitPrice) - 
            ((quantity * unitPrice * bonus) / 100);
          
          const ivaProducto = (subtotalProducto * ivaPercentage) / 100;
          
          // Solo agregar si los valores son válidos
          if (!isNaN(subtotalProducto) && !isNaN(ivaProducto)) {
            totalIva += ivaProducto;

            // Agrupar por porcentaje de IVA
            if (ivaMap.has(ivaPercentage)) {
              const existing = ivaMap.get(ivaPercentage)!;
              existing.baseAmount += subtotalProducto;
              existing.amount += ivaProducto;
            } else {
              ivaMap.set(ivaPercentage, {
                percentage: ivaPercentage,
                baseAmount: subtotalProducto,
                amount: ivaProducto
              });
            }
          }
        }
      });
    }

    // Convertir el Map a array según la estructura del modelo Voucher
    const ivaArray = Array.from(ivaMap.values()).map((iva, index) => ({
      id: ivaRate?.id || (index + 1),
      code: ivaRate?.code || ivaPercentage.toString(),
      name: ivaRate?.name || `IVA ${ivaPercentage}%`,
      baseImp: Math.round(iva.baseAmount * 100) / 100,
      importe: Math.round(iva.amount * 100) / 100
    }));

    return {
      totalIva: Math.round(totalIva * 100) / 100,
      ivaArray
    };
  }

  /**
   * Estructura los tributos configurados para el comprobante
   * @returns Array de tributos estructurados según el modelo Voucher
   */
  estructurarTributos(): any[] {
    return this.tributosComprobante.map((tributo, index) => {
      // Buscar el tributo original para obtener datos completos
      const tributoOriginal = this.tributosDisponibles.find(t => t.id == tributo.tributoId);
      
      return {
        id: tributo.tributoId, // Usar el ID real del tributo
        code: tributoOriginal?.code || `TRIB${index + 1}`, // Usar código del tributo original
        idAfip: tributoOriginal?.idAfip || tributoOriginal?.id || tributo.tributoId, // Usar idAfip del tributo original
        desc: tributo.nombre,
        importe: Number(tributo.monto.toFixed(2)), // Redondear a 2 decimales
        baseImp: Number((tributo.tipo === 'porcentaje' ? 
          (tributo.aplicadoSobre === 1 ? this.subtotal : this.total - this.impuestos) : tributo.monto).toFixed(2)),
        alic: Number((tributo.porcentaje || 0).toFixed(2)) // Alícuota redondeada
      };
    });
  }

  /**
   * Función para validar que solo se ingresen caracteres numéricos y decimales
   * @param event Evento de teclado
   * @returns true si es un carácter válido, false si no lo es
   */
  onlyNumberKey(event): boolean {
    // Permitir números y el punto decimal (para valores con decimales)
    const charCode = event.which ? event.which : event.keyCode;

    // Permitir retroceso (8), tab (9), enter (13), punto decimal (46) y números (48-57)
    if (
      charCode === 8 ||
      charCode === 9 ||
      charCode === 13 ||
      charCode === 46 ||
      (charCode >= 48 && charCode <= 57)
    ) {
      // Si es un punto decimal, verificar que no haya otro punto en el valor
      if (charCode === 46 && event.target.value.includes('.')) {
        event.preventDefault();
        return false;
      }
      return true;
    }

    // Prevenir el evento predeterminado para caracteres no permitidos
    event.preventDefault();
    return false;
  }

  comprobarInput(type, valor, producto) {
    let isError: boolean;
    let maxStock = 0;

    // Corregir el tipado para que sea un objeto Detail individual, no un array
    const productoTabla: Detail | undefined = this.cajaService.articulosList.find(
      x => x.id === producto.id
    );

    // Verificar que productoTabla no sea undefined antes de continuar
    if (!productoTabla) {
      this.openSnackBar('No se encontró el producto', 'Error');
      return;
    }

    const productoTablaIndex = this.cajaService.articulosList.findIndex(
      x => x.id === producto.id
    );

    // Guardar el estado de los campos de fecha antes de las modificaciones
    const fechaEstilo = document
      .querySelector('input[formcontrolname="fecha"]')
      ?.getAttribute('style');
    const fechaDesdeEstilo = document
      .querySelector('input[formcontrolname="fechaDesde"]')
      ?.getAttribute('style');
    const fechaHastaEstilo = document
      .querySelector('input[formcontrolname="fechaHasta"]')
      ?.getAttribute('style');

    // Calcular el subtotal base (cantidad x precio unitario)
    const subtotal: number = productoTabla.quantity * productoTabla.unitPrice;

    switch (type) {
      case 'cantidad':
        // Validar que la cantidad no sea 0
        if (parseFloat(valor) <= 0) {
          this.openSnackBar('La cantidad no puede ser 0 o negativa', 'Error');
          // Establecer directamente a 1 si la cantidad es 0 o negativa
          productoTabla.quantity = 1;
        } else {
          productoTabla.quantity = parseFloat(valor);
        }
        break;
      case 'importe':
        if (productoTabla.unitPrice !== valor) {
          productoTabla.unitPrice = parseFloat(valor);
        }
        break;
      case 'bonif':
        // Validar que la bonificación no supere el 100%
        if (parseFloat(valor) > 100) {
          this.openSnackBar('La bonificación no puede superar el 100%', 'Error');
          // Establecer directamente a 100 si la bonificación supera el 100%
          productoTabla.bonus = 100;
        } else {
          productoTabla.bonus = parseFloat(valor);
        }
        // Actualizar el importe de bonificación según el porcentaje
        const bonif = (subtotal * productoTabla.bonus) / 100;
        productoTabla.bonusAmount = bonif;
        break;
      case 'bonifImporte':
        // Caso nuevo: el usuario ingresa directamente el importe de bonificación
        const importeBonif = parseFloat(valor);

        // Validar que el importe de bonificación no sea mayor que el subtotal
        if (importeBonif > subtotal) {
          this.openSnackBar(
            'El importe de bonificación no puede superar al subtotal',
            'Error'
          );
          // Limitar el importe de bonificación al valor del subtotal
          productoTabla.bonusAmount = subtotal;
          // Establecer el porcentaje a 100%
          productoTabla.bonus = 100;
        } else if (importeBonif < 0) {
          // Si es negativo, establecer a 0
          this.openSnackBar('El importe de bonificación no puede ser negativo', 'Error');
          productoTabla.bonusAmount = 0;
          productoTabla.bonus = 0;
        } else {
          // Asignar el nuevo importe de bonificación
          productoTabla.bonusAmount = importeBonif;

          // Calcular el porcentaje correspondiente
          if (subtotal > 0) {
            // Evitar división por cero
            const porcentajeBonif = (importeBonif / subtotal) * 100;
            // Redondear a 2 decimales para mejor visualización
            productoTabla.bonus = Math.round(porcentajeBonif * 100) / 100;
          } else {
            productoTabla.bonus = 0;
          }
        }
        break;
    }

    // Recalcular subtotales después de todas las modificaciones
    const subtotalActualizado: number = productoTabla.quantity * productoTabla.unitPrice;
    const bonifFinal = (subtotalActualizado * productoTabla.bonus) / 100;
    const total: number = subtotalActualizado - bonifFinal;

    // En caso de que se haya modificado cantidad o precio, actualizar el bonusAmount
    if (type === 'cantidad' || type === 'importe') {
      productoTabla.bonusAmount = bonifFinal;
    }

    // Asegurar que el total sea coherente con el importe de bonificación
    productoTabla.subtotal = total;
    productoTabla.subtotalWithIva = total;

    // Actualizar el producto en la lista
    this.cajaService.articulosList[productoTablaIndex] = productoTabla;

    // Calcular los totales generales
    this.sumarTotalProductos();

    // Restaurar los estilos de los campos de fecha después de las modificaciones
    setTimeout(() => {
      const fechaInput = document.querySelector('input[formcontrolname="fecha"]');
      const fechaDesdeInput = document.querySelector(
        'input[formcontrolname="fechaDesde"]'
      );
      const fechaHastaInput = document.querySelector(
        'input[formcontrolname="fechaHasta"]'
      );

      if (fechaEstilo && fechaInput) fechaInput.setAttribute('style', fechaEstilo);
      if (fechaDesdeEstilo && fechaDesdeInput)
        fechaDesdeInput.setAttribute('style', fechaDesdeEstilo);
      if (fechaHastaEstilo && fechaHastaInput)
        fechaHastaInput.setAttribute('style', fechaHastaEstilo);
    }, 0);
  }

  calcularIvaVenta(precio) {
    const precioSinIva = this.calcularPrecioSinIva(precio);
    this.form.controls.preciosinivaventa.setValue(precioSinIva, {
      onlySelf: true,
    });
  }

  calcularIvaCompra(precio) {
    const precioSinIva = this.calcularPrecioSinIva(precio);
    this.form.controls.preciosinivacompra.setValue(precioSinIva, {
      onlySelf: true,
    });
  }

  calcularPrecioSinIva(precio) {
    let precioSinIva = 0;
    const iva: any = this.typeivas.find(x => x.id === this.form.value.iva);
    if (iva) {
      const ivaValor = iva.nombre.includes('%')
        ? iva.nombre.replace('%', '').trim()
        : '0';
      const convertimosIva = Number.parseFloat(ivaValor.toString());
      const precioIva = (precio * convertimosIva) / 100;
      precioSinIva = precio - precioIva;
    }
    return precioSinIva;
  }

  eliminarProducto(producto) {
    const productoTablaIndex = this.cajaService.articulosList.findIndex(
      x => x.id === producto.id
    );
    this.cajaService.articulosList.splice(productoTablaIndex, 1);
    this.sumarTotalProductos();
  }

  // Método para abrir el modal de detalle libre
  agregarDetalleLibre() {
    if (!this.cliente) {
      this.openSnackBar('Debe seleccionar un cliente primero', 'Error');
      return;
    }

    // Validar que se haya seleccionado un talonario
    const talonarioId = this.form.controls.talonario.value;
    if (!talonarioId) {
      this.openSnackBar('Debe seleccionar un talonario antes de agregar detalles', 'Advertencia');
      return;
    }

    // Resetear el formulario
    this.detalleLibreForm.reset({
      codigo: '', // Nuevo campo para código personalizado
      descripcion: '',
      cantidad: 1,
      unidad: '',
      precio: 0,
      bonificacion: 0,
    });

    // Abrir el diálogo
    this.dialogRef = this.dialog.open(this.detalleLibreModal, {
      width: '600px',
      disableClose: true,
    });
  }

  // Método para calcular el importe de la bonificación
  calcularImporteBonificacion(): number {
    if (this.detalleLibreForm) {
      const cantidad = this.detalleLibreForm.get('cantidad').value || 0;
      const precio = this.detalleLibreForm.get('precio').value || 0;
      const bonificacion = this.detalleLibreForm.get('bonificacion').value || 0;

      const subtotal = cantidad * precio;
      return (subtotal * bonificacion) / 100;
    }
    return 0;
  }

  // Método para calcular el total del detalle libre
  calcularTotalDetalleLibre(): number {
    if (this.detalleLibreForm) {
      const cantidad = this.detalleLibreForm.get('cantidad').value || 0;
      const precio = this.detalleLibreForm.get('precio').value || 0;
      const bonificacion = this.detalleLibreForm.get('bonificacion').value || 0;

      const subtotal = cantidad * precio;
      const descuento = (subtotal * bonificacion) / 100;

      return subtotal - descuento;
    }
    return 0;
  }

  // Método para actualizar el importe de bonificación cuando cambia el porcentaje
  actualizarBonifImporte() {
    const cantidad = this.detalleLibreForm.get('cantidad').value || 0;
    const precio = this.detalleLibreForm.get('precio').value || 0;
    const bonificacion = this.detalleLibreForm.get('bonificacion').value || 0;

    const subtotal = cantidad * precio;
    const importe = subtotal * (bonificacion / 100);

    // Actualizar el campo de importe sin disparar el evento change
    this.detalleLibreForm
      .get('bonificacionImporte')
      .setValue(importe, { emitEvent: false });
  }

  // Método para actualizar el porcentaje de bonificación cuando cambia el importe
  actualizarBonifPorcentaje() {
    const cantidad = this.detalleLibreForm.get('cantidad').value || 0;
    const precio = this.detalleLibreForm.get('precio').value || 0;
    const importeBonif = this.detalleLibreForm.get('bonificacionImporte').value || 0;

    const subtotal = cantidad * precio;

    // Evitar división por cero
    if (subtotal > 0) {
      const porcentaje = (importeBonif / subtotal) * 100;
      // Redondear a 2 decimales para mejor visualización
      const porcentajeRedondeado = Math.round(porcentaje * 100) / 100;

      // Validar que el porcentaje no supere el 100%
      if (porcentajeRedondeado > 100) {
        this.openSnackBar('La bonificación no puede superar el 100%', 'Error');
        // Limitar el importe al subtotal y el porcentaje a 100%
        this.detalleLibreForm.get('bonificacionImporte').setValue(subtotal);
        this.detalleLibreForm.get('bonificacion').setValue(100, { emitEvent: false });
      } else {
        // Actualizar el campo de porcentaje sin disparar el evento change
        this.detalleLibreForm
          .get('bonificacion')
          .setValue(porcentajeRedondeado, { emitEvent: false });
      }
    } else {
      // Si el subtotal es 0, establecer el porcentaje a 0
      this.detalleLibreForm.get('bonificacion').setValue(0, { emitEvent: false });
    }
  }

  // Método para guardar el detalle libre
  guardarDetalleLibre() {
    if (this.detalleLibreForm.valid) {
      const formValues = this.detalleLibreForm.value;
      // Crear un nuevo detalle libre
      const detalleLibre: Detail = {
        id: null,
        code: formValues.codigo || '0001', // Código único para el detalle libre
        description: formValues.descripcion,
        type: 'detalle_libre', // Tipo especial para identificar que es un detalle libre
        variantId: 0, // No está asociado a una variante de producto
        voucherId: 0, // Se asignará cuando se guarde el comprobante
        quantity: formValues.cantidad,
        unitPrice: formValues.precio,
        measurementUnitId: this.getUnidadMedidaPorCodigo(formValues.unidad)?.id || 0, // Obtener el ID de la unidad de medida
        bonus: formValues.bonificacion || 0,
        bonusAmount: this.calcularBonificacion(
          formValues.cantidad,
          formValues.precio,
          formValues.bonificacion
        ),
        subtotalWithIva: this.calcularTotalDetalleLibre(),
        subtotal: this.calcularTotalDetalleLibre(),
        batch: '',
        conversionUnitId: 0,
        conversionUnits: [],
      };

      // Añadir la unidad de medida personalizada
      detalleLibre['unidadMedida'] = formValues.unidad;

      // Agregar el detalle a la lista de artículos
      this.cajaService.addArticulo(detalleLibre);

      // Recalcular totales
      this.sumarTotalProductos();

      // Cerrar el diálogo
      this.dialogRef.close();
    } else {
      this.openSnackBar('Formulario inválido. Verifique los campos', 'Error');
    }
  }

  // Método para calcular la bonificación
  calcularBonificacion(cantidad: number, precio: number, porcentaje: number): number {
    const subtotal = cantidad * precio;
    return subtotal * (porcentaje / 100);
  }

  // Método para determinar si se debe mostrar el campo de comprobante relacionado
  debeMostrarComprobanteRelacionado(): boolean {
    // Mostrar el selector para notas de crédito y débito
    return (
      this.typeComprobante === 'notadecredito' || this.typeComprobante === 'notadedebito'
    );
  }

  // Método para determinar si se deben mostrar los campos CAE
  debeMostrarCamposCAE(): boolean {
    // Mostrar CAE para facturas, notas de crédito y notas de débito
    return (
      this.typeComprobante === 'factura' || 
      this.typeComprobante === 'notadecredito' || 
      this.typeComprobante === 'notadedebito'
    );
  }

  // Método para buscar comprobantes que se pueden relacionar
  buscarComprobantesRelacionados() {
    if (!this.cliente) {
      this.openSnackBar('Debe seleccionar un cliente primero', 'Error');
      return;
    }

    // Si es nota de crédito o débito, buscar facturas del cliente
    if (
      this.typeComprobante === 'notadecredito' ||
      this.typeComprobante === 'notadedebito'
    ) {
      
    }
  }

  guardarPedido() {
    // Activar spinner de carga
    this.isCreatingVoucher = true;
    
    // Validar campos obligatorios para compras (excepto pedidos de compra)
    if (this.esOperacionCompra() && !this.esPedidoDeCompra()) {
      const puntoVenta = this.form.controls.puntoVentaManual.value;
      const numeroComprobante = this.form.controls.numeroComprobanteManual.value;
      
      if (!puntoVenta || puntoVenta < 1) {
        this.isCreatingVoucher = false;
        this.openSnackBar('Debe ingresar el Punto de Venta del proveedor', 'Error');
        return;
      }
      
      if (!numeroComprobante || numeroComprobante < 1) {
        this.isCreatingVoucher = false;
        this.openSnackBar('Debe ingresar el Número de Comprobante del proveedor', 'Error');
        return;
      }
    }
    
    // Validar que se haya seleccionado un talonario
    const talonarioId = this.form.controls.talonario.value;
    if (!talonarioId) {
      this.isCreatingVoucher = false;
      this.openSnackBar('Debe seleccionar un talonario', 'Error');
      return;
    }

    const talonarioSeleccionado = this.talariosFiltrados.find(t => t.id === talonarioId);
    if (!talonarioSeleccionado) {
      this.isCreatingVoucher = false;
      this.openSnackBar('Talonario seleccionado no válido', 'Error');
      return;
    }

    // Cabecera - Usar formato MySQL (YYYY-MM-DD)
    let fecha = dayjs(this.fecha.value).format('YYYY-MM-DD');
    let fechaDesde = dayjs(this.fechaDesde.value).format('YYYY-MM-DD');
    let fechaHasta = dayjs(this.fechaHasta.value).format('YYYY-MM-DD');
    
    // Verificar si el tipo de operación es "Productos"
    const conceptoSeleccionado = this.conceptos.find(x => x.id === this.form.controls.concepto.value);
    const esConceptoProductos = this.esConceptoDeProductos(conceptoSeleccionado);
    
    // Debug: Mostrar el concepto seleccionado y si es de productos
    console.log('Concepto seleccionado:', conceptoSeleccionado);
    console.log('Es concepto de productos:', esConceptoProductos);
    
    // Usar información del talonario seleccionado - asegurar inicialización completa
    this.cabecera.receiptBookId = Number(talonarioSeleccionado.id) || 0;
    
    // Si es una operación de compra y hay número manual, usarlo
    if (this.esOperacionCompra() && this.form.controls.numeroComprobanteManual.value) {
      this.cabecera.number = Number(this.form.controls.numeroComprobanteManual.value);
    } else {
      this.cabecera.number = Number(talonarioSeleccionado.currentNumber) || 0;
    }
    
    this.cabecera.saleCondition = this.form.controls.condiventa.value || '';
    this.cabecera.issuerCuit = this.cliente.documentNumber || '';
    
    // Limitar el tamaño del campo address a máximo 255 caracteres
    const fullAddress = this.cabecera.address || this.cliente.address || '';
    this.cabecera.address = fullAddress.length > 255 ? fullAddress.substring(0, 255) : fullAddress;
    
    // Si el concepto es "Productos", usar la misma fecha para los tres campos
    if (esConceptoProductos) {
      this.cabecera.dateFrom = fecha;
      this.cabecera.dateTo = fecha;
      this.cabecera.expirationDate = fecha;
    } else {
      // Para otros conceptos, usar las fechas específicas como antes
      this.cabecera.dateFrom = fecha;
      this.cabecera.dateTo = fechaHasta;
      this.cabecera.expirationDate = fechaDesde;
    }
    
    // Limitar campos de texto para evitar errores de "Data too long"
    this.cabecera.grossIncome = (this.cabecera.grossIncome || '').substring(0, 50);
    this.cabecera.activityStartDate = (this.cabecera.activityStartDate || '').substring(0, 50);
    
    const fullSocialReason = this.cabecera.socialReason || this.cliente.companyName || '';
    this.cabecera.socialReason = fullSocialReason.length > 255 ? fullSocialReason.substring(0, 255) : fullSocialReason;
    
    this.cabecera.priceListId = Number(this.form.controls.priceListId.value) || 1; // Asegurar que siempre tenga un valor
    
    // Si es una operación de compra y hay valores manuales, usarlos
    if (this.esOperacionCompra() && this.form.controls.puntoVentaManual.value) {
      this.cabecera.salesPointsId = Number(this.form.controls.puntoVentaManual.value);
    } else {
      this.cabecera.salesPointsId = Number(this.punto) || Number(talonarioSeleccionado.salesPointsId) || 0;
    }
    
    // Comprobante
    this.comprobante.recordQuantity = this.cajaService.articulosList.length;
    this.comprobante.header = this.cabecera;
    
    // Limitar campos de texto en comprobante
    this.comprobante.cae = (this.form.controls.cae.value || '').substring(0, 100);
    this.comprobante.barCode = '';
    
    const fullComment = this.form.controls.comentario.value || '';
    this.comprobante.comment = fullComment.length > 500 ? fullComment.substring(0, 500) : fullComment;
    
    this.comprobante.associatedVouchers = [];
    let concepto = this.conceptos.find(x => x.id === this.form.controls.concepto.value);
    this.comprobante.conceptId = Number(concepto ? concepto.id : 0);
    this.comprobante.currencyId = Number(this.form.controls.moneda.value) || 0;
    this.comprobante.client = this.cliente;
    this.comprobante.electronic = 0;
    this.comprobante.sent = 0;
    this.comprobante.status = 'creado';
    this.comprobante.type = this.type === 'ventas' ? 'Entrada' : 'Salida';
    
    // Configurar fecha de vencimiento CAE (formato MySQL: YYYY-MM-DD)
    const fechaVencimientoCae = this.form.controls.fechaVencimientoCae.value;
    this.comprobante.expirationDateCae = fechaVencimientoCae ? 
      dayjs(fechaVencimientoCae).format('YYYY-MM-DD') : '';

    // Calcular y estructurar IVA de los productos
    const ivaData = this.calcularIvaProductos();
    this.comprobante.ivaAmount = ivaData.totalIva;
    this.comprobante.iva = ivaData.ivaArray;

    // Estructurar tributos configurados solo si hay tributos
    this.comprobante.tributes = this.tributosComprobante.length > 0 ? 
      this.estructurarTributos() : [];

    this.comprobante.netAmount = Number(this.subtotal.toFixed(2));
    this.comprobante.exportAmount = 0;
    this.comprobante.totalExemptConceptAmount = 0;
    this.comprobante.taxableAmount = 0;
    this.comprobante.totalAmount = Number(this.total.toFixed(2));
    this.comprobante.currencyQuotation = 0;

    // Añadir comprobante relacionado si existe
    const comprobanteRelacionadoId = this.form.controls.comprobanteRelacionadoId.value;
    if (comprobanteRelacionadoId) {
      this.comprobante.relatedVoucherId = Number(comprobanteRelacionadoId) || 0;
    }

    // Transformar cada artículo para asegurar que cumple con la estructura Detail
    const detailItems: Detail[] = this.cajaService.articulosList.map(articulo => {
      // Calcular bonificación si no está presente - asegurar conversión a número
      const quantity = Number(articulo.quantity) || 0;
      const unitPrice = Number(articulo.unitPrice) || 0;
      const bonus = Number(articulo.bonus) || 0;
      
      const subtotal = quantity * unitPrice;
      const bonif = bonus ? (subtotal * bonus) / 100 : 0;

      // Crear un objeto Detail con todas las propiedades requeridas
      const detailItem: Detail = {
        id: articulo.id,
        code: articulo.code || '',
        description: articulo.description || '',
        // Mantener el tipo original (producto o detalle_libre)
        type: articulo.type || 'producto',
        variantId:
          articulo.type === 'detalle_libre' ? 0 : articulo.variantId || articulo.id || 0,
        voucherId: articulo.voucherId || 0,
        quantity: quantity,
        unitPrice: unitPrice,
        bonus: bonus,
        bonusAmount: Number(articulo.bonusAmount) || bonif,
        subtotalWithIva: articulo.subtotalWithIva || subtotal - bonif,
        subtotal: articulo.subtotal || subtotal - bonif,
        batch: articulo.batch || '',
        conversionUnitId: articulo.conversionUnitId || 0,
      };

      // Si es un detalle libre y tiene unidad de medida personalizada
      if (articulo.type === 'detalle_libre' && articulo['unidadMedida']) {
        detailItem['unidadMedida'] = articulo['unidadMedida'];
      }

      return detailItem;
    });

    this.comprobante.urlReceipt = this.urlComprobante ? this.urlComprobante : null;

    // Asignar el array de detalles correctamente tipado
    this.comprobante.detail = detailItems;

    // Verificar si hay valores NaN en el objeto
    const comprobanteStr = JSON.stringify(this.comprobante);
    if (comprobanteStr.includes('NaN')) {
      this.isCreatingVoucher = false;
      this.openSnackBar('Error: Hay valores inválidos en el comprobante', 'Error');
      return;
    }

    // Para remitos y presupuestos, permitir creación incluso con total 0, solo validar que tenga productos
    // Para otros comprobantes, validar que recordQuantity > 0
    const puedeCrear = (this.typeComprobante === 'remito' || this.typeComprobante === 'presupuesto')
      ? this.cajaService.articulosList.length > 0 
      : this.comprobante.recordQuantity > 0;

    if (puedeCrear) {
      // Determinar si estamos creando o actualizando
      if (this.operacion === 'edit' && this.comprobanteId) {
        // Modo actualización
        this.comprobanteSerice.actualizarComprobante(this.comprobanteId, this.comprobante).subscribe(
          data => {
            this.isCreatingVoucher = false;
            const tipoComprobante = this.getTipoComprobanteDisplay();
            
            // Mostrar mensaje de éxito para actualización
            Swal.fire({
              title: '¡Actualizado!',
              text: `${tipoComprobante} actualizado correctamente`,
              icon: 'success',
              showCancelButton: true,
              confirmButtonText: '<i class="material-icons">print</i> Imprimir',
              cancelButtonText: 'Cerrar',
              confirmButtonColor: '#102dd3',
              cancelButtonColor: '#66615b',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                // Imprimir el comprobante actualizado
                this.imprimirComprobante(data);
              }
              // Volver a la lista de comprobantes
              this.salir();
            });
          },
          err => {
            this.isCreatingVoucher = false;
            console.log(err);
            const tipoComprobante = this.getTipoComprobanteDisplay();
            Swal.fire({
              title: 'Error',
              text: `Error al actualizar ${tipoComprobante.toLowerCase()}`,
              icon: 'error',
              confirmButtonText: 'Entendido',
              confirmButtonColor: '#ef8157'
            });
          }
        );
      } else {
        // Modo creación
        this.comprobanteSerice.guardarComprobante(this.comprobante).subscribe(
          data => {
            this.isCreatingVoucher = false;
            const tipoComprobante = this.getTipoComprobanteDisplay();
            
            // Mostrar mensaje de éxito con SweetAlert2 y opción de impresión
            Swal.fire({
              title: '¡Éxito!',
              text: `${tipoComprobante} creado correctamente`,
              icon: 'success',
              showCancelButton: true,
              confirmButtonText: '<i class="material-icons">print</i> Imprimir',
              cancelButtonText: 'Cerrar',
              confirmButtonColor: '#102dd3',
              cancelButtonColor: '#66615b',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                // Imprimir el comprobante
                this.imprimirComprobante(data);
              }
              // Volver a la lista de comprobantes
              this.salir();
            });
          },
          err => {
            this.isCreatingVoucher = false;
            console.log(err);
            const tipoComprobante = this.getTipoComprobanteDisplay();
            Swal.fire({
              title: 'Error',
              text: `Error al crear ${tipoComprobante.toLowerCase()}`,
              icon: 'error',
              confirmButtonText: 'Entendido',
              confirmButtonColor: '#ef8157'
            });
          }
        );
      }
    } else {
      this.isCreatingVoucher = false;
      this.openSnackBar('Debe agregar al menos un producto', 'Error');
    }
  }

  // Métodos de utilidad para trabajar con unidades de medida

  /**
   * Obtiene una unidad de medida por su ID
   * @param id ID de la unidad de medida
   * @returns La unidad de medida o undefined si no se encuentra
   */
  getUnidadMedidaPorId(id: number): MeasurementUnit | undefined {
    return this.medidas?.find(unidad => unidad.id === id);
  }

  /**
   * Obtiene una unidad de medida por su código
   * @param codigo Código de la unidad de medida
   * @returns La unidad de medida o undefined si no se encuentra
   */
  getUnidadMedidaPorCodigo(codigo: string): MeasurementUnit | undefined {
    return this.medidas?.find(unidad => unidad.code === codigo);
  }

  /**
   * Obtiene el nombre de una unidad de medida por su ID
   * @param id ID de la unidad de medida
   * @returns El nombre de la unidad o 'Desconocida' si no se encuentra
   */
  getNombreUnidadMedida(id: number): string {
    const unidad = this.getUnidadMedidaPorId(id);
    return unidad ? unidad.name : 'Desconocida';
  }

  /**
   * Carga los datos de parámetros incluyendo unidades de medida
   * Combina los datos de parametrosComprobantes y parametrosArticulos
   */
  cargarParametrosCompletos() {
    // Usar forkJoin para ejecutar ambas llamadas en paralelo
    forkJoin({
      comprobantes: this.parametroServicio.getParametrosComprobantes(),
      articulos: this.parametroServicio.getParametrosArticulos(),
    }).subscribe(
      ({ comprobantes, articulos }) => {
        // Datos de comprobantes
        this.monedas = comprobantes.currencies;
        this.typeivas = comprobantes.vatRates;
        this.conceptos = comprobantes.concepts;
        this.otrostributos = comprobantes.taxes;
        this.typeComprobantes = comprobantes.voucherTypes;

        // Datos de artículos
        this.medidas = articulos.umedidas || [];

        // Procesamiento de conceptos
        let indiceOtros = this.conceptos.findIndex(x =>
          x.description?.toLowerCase()?.includes('otros')
        );
        if (indiceOtros >= 0) {
          this.conceptos.splice(indiceOtros, 1);
        }

        // Configuración de valores predeterminados
        this.configurarValoresPredeterminados();

        // Configuración del comprobante según su tipo
        this.configurarTipoComprobante();

        // Obtener número de comprobante si es una creación
        if (this.operacion === 'create') {
          this.getNumeroComprobante();
        }
      },
      err => {
        console.log(err);
        this.openSnackBar('Error al cargar parámetros', 'Error');
      }
    );
  }

  /**
   * Configura los valores predeterminados en el formulario
   */
  configurarValoresPredeterminados() {
    // Concepto predeterminado basado en el tipo de comprobante
    let codigoConcepto = '1'; // Valor por defecto
    
    // Configurar concepto específico según tipo de comprobante
    if (this.type === 'ventas') {
      if (this.typeComprobante === 'remito') {
        // Para remitos, buscar "Productos" o "Venta de productos"
        codigoConcepto = '1'; // Productos (código estándar)
      } else if (this.typeComprobante === 'factura') {
        codigoConcepto = '1'; // Productos
      } else if (this.typeComprobante === 'notadecredito' || this.typeComprobante === 'notadedebito') {
        codigoConcepto = '1'; // Productos
      }
    }
    
    const concepto = this.conceptos.find(x => x.code === codigoConcepto);
    if (concepto) {
      this.form.controls.concepto.setValue(concepto.id, { onlySelf: true });
    }

    // IVA predeterminado
    const type = this.typeivas.find(x => x.code === '5');
    if (type) {
      this.form.controls.iva.setValue(type.id, { onlySelf: true });
    }

    // Moneda predeterminada
    const moneda = this.monedas.find(x => x.code === 'PES');
    if (moneda) {
      this.form.controls.moneda.setValue(moneda.id, { onlySelf: true });
    }
  }

  /**
   * Método mejorado para obtener el tipo de comprobante según type y typeComprobante
   * Busca por receiptBookTypeId que corresponda al tipo de comprobante solicitado
   */
  obtenerTipoComprobanteDB(): VoucherTypes | undefined {
    // Primero, necesitamos obtener información sobre los ReceiptBookTypes disponibles
    // para mapear correctamente los tipos de comprobante
    
    // Mapeo de tipos de comprobante a IDs o nombres esperados de ReceiptBookType
    const mapeoTiposComprobante = {
      'pedido': this.buscarVoucherTypePorTipo('pedido'),
      'presupuesto': this.buscarVoucherTypePorTipo('presupuesto'),
      'remito': this.buscarVoucherTypePorTipo('remito'),
      'recibo': this.buscarVoucherTypePorTipo('recibo'),
      'factura': this.buscarVoucherTypePorTipo('factura'),
      'notadecredito': this.buscarVoucherTypePorTipo('nota de credito'),
      'notadedebito': this.buscarVoucherTypePorTipo('nota de debito')
    };

    // Buscar el tipo de comprobante correspondiente
    let tipoEncontrado = mapeoTiposComprobante[this.typeComprobante];

    if (!tipoEncontrado) {
      // Fallback: intentar buscar por código como antes
      const codigoFallback = this.obtenerCodigoComprobanteComoFallback();
      
      if (codigoFallback) {
        tipoEncontrado = this.typeComprobantes.find(x => x.code === codigoFallback);
      }
    }

    return tipoEncontrado;
  }

  /**
   * Busca un VoucherType que corresponda al tipo de comprobante especificado
   * Considera el tipo de operación (ventas/compras) y el nombre/descripción
   * También intenta buscar por receiptBookTypeId si está disponible
   */
  private buscarVoucherTypePorTipo(tipoComprobante: string): VoucherTypes | undefined {
    const tipoOperacion = this.type || 'ventas';
    
    // Convertir tipo de operación a formato esperado
    const operationTypeMap = {
      'ventas': 'sales',
      'compras': 'purchase'
    };
    
    const operationType = operationTypeMap[tipoOperacion];

    // Términos de búsqueda más flexibles
    const terminosBusqueda = {
      'pedido': ['pedido', 'order', 'orden'],
      'presupuesto': ['presupuesto', 'budget', 'quotation', 'quote'],
      'remito': ['remito', 'delivery', 'shipment', 'envio'],
      'recibo': ['recibo', 'receipt', 'voucher'],
      'factura': ['factura', 'invoice', 'bill'],
      'nota de credito': ['credito', 'credit', 'nc'],
      'nota de debito': ['debito', 'debit', 'nd']
    };

    const terminos = terminosBusqueda[tipoComprobante] || [tipoComprobante];

    // Buscar en typeComprobantes - MENOS RESTRICTIVO con operationType
    let candidatos = this.typeComprobantes.filter(voucherType => {
      // Buscar por nombre, descripción o código que contenga el tipo de comprobante
      const nombre = (voucherType.name || voucherType.description || '').toLowerCase();
      const codigo = voucherType.code?.toLowerCase() || '';
      
      return terminos.some(termino => 
        nombre.includes(termino) || 
        codigo.includes(termino)
      );
    });

    // Si encontramos candidatos, elegir el más apropiado
    if (candidatos.length > 0) {
      // Preferir el que tenga operationType exacto si está disponible
      const conOperationType = candidatos.find(c => c.operationType === operationType);
      if (conOperationType) {
        return conOperationType;
      }

      // Si no hay coincidencia exacta de operationType, tomar el primero
      return candidatos[0];
    }

    // Si no encontramos por descripción/nombre, intentar buscar por receiptBookTypeId
    // Este sería el enfoque ideal si tenemos información sobre los ReceiptBookTypes
    return this.buscarPorReceiptBookTypeId(tipoComprobante, operationType);
  }

  /**
   * Busca VoucherType por receiptBookTypeId
   * Método más preciso si la información de ReceiptBookType está disponible
   */
  private buscarPorReceiptBookTypeId(tipoComprobante: string, operationType?: string): VoucherTypes | undefined {
    // Si tenemos acceso a los ReceiptBookTypes, podríamos hacer una búsqueda más precisa
    // Por ahora, esto serviría como placeholder para futuras mejoras cuando 
    // tengamos acceso completo a la estructura de ReceiptBookTypes
    
    // Mapeo aproximado de tipos de comprobante a IDs de ReceiptBookType
    // Estos valores deberían venir idealmente de una consulta a la API
    const receiptBookTypeMapping = {
      'factura': [1, 2, 3], // IDs típicos para facturas A, B, C
      'presupuesto': [4],
      'remito': [5],
      'recibo': [6],
      'notadecredito': [7],
      'notadedebito': [8],
      'pedido': [9]
    };

    const receiptBookTypeIds = receiptBookTypeMapping[tipoComprobante];
    
    if (receiptBookTypeIds) {
      const encontrado = this.typeComprobantes.find(voucherType => 
        receiptBookTypeIds.includes(voucherType.receiptBookTypeId)
      );
      
      if (encontrado) {
        return encontrado;
      }
    }

    return undefined;
  }

  /**
   * Método de fallback para obtener código de comprobante cuando no se encuentra por ReceiptBooks
   */
  private obtenerCodigoComprobanteComoFallback(): string | null {
    const tipoOperacion = this.type || 'ventas';
    let codigoComprobante = ComprobanteComponent.CODIGOS_COMPROBANTES[tipoOperacion]?.[this.typeComprobante];

    if (!codigoComprobante && tipoOperacion !== 'ventas') {
      codigoComprobante = ComprobanteComponent.CODIGOS_COMPROBANTES.ventas[this.typeComprobante];
    }

    return codigoComprobante || null;
  }

  /**
   * Obtiene el código del comprobante según el tipo de operación y tipo de comprobante
   * Centraliza la lógica de mapeo de códigos usando la configuración estática
   */
  private obtenerCodigoComprobante(): string | null {
    // Obtener el código correspondiente al tipo de operación y tipo de comprobante
    const tipoOperacion = this.type || 'ventas';
    let codigoComprobante = ComprobanteComponent.CODIGOS_COMPROBANTES[tipoOperacion]?.[this.typeComprobante];

    // Si no se encuentra en el tipo de operación específico, usar ventas como fallback
    if (!codigoComprobante && tipoOperacion !== 'ventas') {
      codigoComprobante = ComprobanteComponent.CODIGOS_COMPROBANTES.ventas[this.typeComprobante];
    }

    return codigoComprobante || null;
  }

  /**
   * Configura el tipo de comprobante según su código
   * @deprecated Usar obtenerTipoComprobanteDB() en su lugar
   */
  configurarTipoComprobante() {
    this.typeComprobanteDB = this.obtenerTipoComprobanteDB();
  }

  /**
   * Método utilitario para obtener todos los tipos de comprobantes disponibles
   * para un tipo de operación específico
   */
  obtenerTiposComprobanteDisponibles(tipoOperacion: string = this.type): string[] {
    return Object.keys(ComprobanteComponent.CODIGOS_COMPROBANTES[tipoOperacion] || {});
  }

  /**
   * Método utilitario para verificar si un tipo de comprobante es válido
   * para el tipo de operación actual. Ahora considera receiptBookTypeId
   */
  esTipoComprobanteValido(tipoComprobante: string): boolean {
    const tipoEncontrado = this.buscarVoucherTypePorTipo(tipoComprobante);
    return !!tipoEncontrado;
  }

  /**
   * Método utilitario para obtener información detallada del tipo de comprobante actual
   */
  obtenerInfoTipoComprobante(): any {
    const tipoComprobante = this.obtenerTipoComprobanteDB();
    if (!tipoComprobante) {
      return null;
    }

    return {
      id: tipoComprobante.id,
      code: tipoComprobante.code,
      name: tipoComprobante.name || tipoComprobante.description,
      operationType: tipoComprobante.operationType,
      receiptBookTypeId: tipoComprobante.receiptBookTypeId,
      description: tipoComprobante.description
    };
  }

  uploadReceiptFile() {
    const dialogRef = this.dialog.open(UploadFileComponent, {
      minWidth: '40%',
      minHeight: '400',
      disableClose: true,
      data: {
        mensaje: 'Subir una imagen o un pdf con el comprobante de pago',
        type: this.type,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.urlComprobante = result;
      }
    });
  }

  /**
   * Método para actualizar los precios de los artículos según la lista de precios seleccionada
   * @param priceListId ID de la lista de precios seleccionada
   */
  actualizarPreciosArticulos(priceListId: number | string) {
    if ((priceListId === null || priceListId === undefined || priceListId === '') || this.cajaService.articulosList.length === 0) {
      return;
    }

    // Obtener la lista de precios seleccionada
    const listaPrecioSeleccionada = this.priceLists.find(
      lista => lista.code === priceListId.toString() || lista.id === priceListId
    );

    if (!listaPrecioSeleccionada || !listaPrecioSeleccionada.articulos) {
      console.warn('Lista de precios no encontrada o sin artículos');
      return;
    }

    let articulosActualizados = 0;

    // Actualizar el precio de cada artículo según la lista de precios
    this.cajaService.articulosList.forEach(articulo => {
      // Buscar el precio correspondiente en la lista de precios
      // Buscar por variantId primero, luego por id como fallback
      const articuloEnLista = listaPrecioSeleccionada.articulos.find(
        articuloLista => 
          articuloLista.id === articulo.variantId || 
          articuloLista.id === articulo.id ||
          articuloLista.variantId === articulo.variantId
      );

      if (articuloEnLista) {
        // Determinar el precio a usar (customPrice tiene prioridad, luego price)
        const nuevoPrecio = articuloEnLista.customPrice || articuloEnLista.price || articulo.unitPrice;
        
        if (nuevoPrecio && nuevoPrecio !== articulo.unitPrice) {
          // Actualizar el precio del artículo
          articulo.unitPrice = nuevoPrecio;
          
          // Recalcular el subtotal
          const cantidadXPrecio = articulo.quantity * articulo.unitPrice;
          const bonif = (articulo.bonus * cantidadXPrecio) / 100;
          articulo.subtotal = cantidadXPrecio - bonif;
          articulo.subtotalWithIva = cantidadXPrecio - bonif;
          
          articulosActualizados++;
        }
      }
    });

    if (articulosActualizados > 0) {
      // Recalcular los totales después de actualizar los precios
      this.sumarTotalProductos();
      
      // Mostrar mensaje informativo
      this.openSnackBar(`Se actualizaron los precios de ${articulosActualizados} artículo(s)`, 'Información');
    }
  }

  abrirDialogoTributos() {
    this.tributoForm.reset({ 
      tributoId: '', 
      tipo: 'monto',
      monto: 0, 
      porcentaje: 0 
    });
    this.tributoSeleccionado = null; // Resetear tributo seleccionado
    this.dialogRef = this.dialog.open(this.dialogoTributos, {
      width: '500px',
      disableClose: true
    });
  }

  guardarTributo() {
    if (this.tributoForm.valid) {
      const tributoId = this.tributoForm.get('tributoId')?.value;
      const tributoSeleccionado = this.tributosDisponibles.find(t => t.id == tributoId);
      
      if (!tributoSeleccionado) {
        this.openSnackBar('Debe seleccionar un tributo válido', 'OK');
        return;
      }

      // Verificar si el tributo ya fue agregado
      const tributoExistente = this.tributosComprobante.find(t => t.tributoId == tributoId);
      if (tributoExistente) {
        this.openSnackBar('Este tributo ya fue agregado al comprobante', 'OK');
        return;
      }

      // Usar descripción personalizada si existe, sino usar la del tributo
      const descripcionPersonalizada = this.tributoForm.get('descripcionPersonalizada')?.value;
      const nombre = descripcionPersonalizada && descripcionPersonalizada.trim() !== '' 
        ? descripcionPersonalizada.trim() 
        : tributoSeleccionado.desc;

      // Usar el porcentaje ingresado manualmente
      const porcentajeManual = this.tributoForm.get('porcentaje')?.value;
      
      if (!porcentajeManual || porcentajeManual <= 0) {
        this.openSnackBar('Debe ingresar un porcentaje válido mayor a 0', 'OK');
        return;
      }

      const tipo: 'porcentaje' = 'porcentaje';
      const porcentaje = porcentajeManual;
      const aplicadoSobre = this.subtotal;
      const monto = Number(((aplicadoSobre * porcentaje) / 100).toFixed(2));

      const tributo = {
        nombre,
        monto,
        tipo,
        porcentaje: porcentaje,
        aplicadoSobre: aplicadoSobre,
        tributoId: tributoId // Agregar el ID para referencia
      };

      this.tributosComprobante.push(tributo);
      this.actualizarTotalTributos();
      
      // Resetear el formulario para el próximo tributo
      this.tributoForm.reset({
        tributoId: '',
        tipo: 'monto',
        monto: 0,
        porcentaje: 0,
        descripcionPersonalizada: ''
      });
      this.tributoSeleccionado = null;
      
      this.dialogRef.close();
    }
  }

  eliminarTributo(index: number) {
    this.tributosComprobante.splice(index, 1);
    this.actualizarTotalTributos();
  }

  /**
   * Actualiza el total de "Otros Impuestos" con la suma de todos los tributos
   */
  actualizarTotalTributos() {
    const totalTributos = this.tributosComprobante.reduce((total, tributo) => total + tributo.monto, 0);
    this.impuestos = Number(totalTributos.toFixed(2)); // Redondear a 2 decimales
    this.sumarTotalProductos(); // Recalcular el total general
  }

  /**
   * Recalcula los tributos porcentuales cuando cambia el subtotal
   */
  recalcularTributosConPorcentaje() {
    let cambioRealizado = false;
    this.tributosComprobante.forEach(tributo => {
      if (tributo.tipo === 'porcentaje' && tributo.porcentaje) {
        const nuevoMonto = Number(((this.subtotal * tributo.porcentaje) / 100).toFixed(2));
        if (tributo.monto !== nuevoMonto) {
          tributo.monto = nuevoMonto;
          tributo.aplicadoSobre = this.subtotal;
          cambioRealizado = true;
        }
      }
    });
    
    // Solo actualizar si hubo cambios para evitar recursión infinita
    if (cambioRealizado) {
      const totalTributos = this.tributosComprobante.reduce((total, tributo) => total + tributo.monto, 0);
      this.impuestos = Number(totalTributos.toFixed(2));
    }
  }

  /**
   * Obtiene el total de todos los tributos para mostrar en el template
   */
  obtenerTotalTributos(): number {
    const total = this.tributosComprobante.reduce((total, tributo) => total + tributo.monto, 0);
    return Number(total.toFixed(2));
  }

  /**
   * Inicializa los tributos basándose en el valor de impuestos existente
   * Se usa cuando se carga un comprobante existente
   */
  inicializarTributosDesdeImpuestos() {
    // Limpiar tributos existentes
    this.tributosComprobante = [];
    
    // Si hay impuestos, crear un tributo genérico
    if (this.impuestos > 0) {
      this.tributosComprobante.push({
        nombre: 'Otros Impuestos',
        monto: this.impuestos,
        tipo: 'monto'
      });
    }
  }

  /**
   * Filtra los talonarios según el tipo de comprobante configurado y normativa fiscal argentina
   */
  filtrarTalonarios() {
    if (!this.talonarios || !this.talonarios.length) {
      this.talariosFiltrados = [];
      console.warn('❌ No hay talonarios disponibles');
      return;
    }

    console.log('🔍 INICIANDO FILTRADO DE TALONARIOS');
    console.log('📊 Total de talonarios:', this.talonarios.length);
    console.log('📋 Tipo de comprobante:', this.typeComprobante);
    console.log('🏢 Tipo de operación:', this.type);
    console.log('🆔 typeComprobanteDB:', this.typeComprobanteDB);
    console.log('👤 Cliente responsableTypeId:', this.cliente?.responsibleTypeId);

    // SIEMPRE usar el método alternativo que filtra por punto de venta y tipo de operación
    // Este método es más flexible y muestra todos los talonarios disponibles del punto de venta Principal
    console.log('✅ Usando método alternativo para filtrar por Punto de Venta ID=1 y tipo de operación');
    let talonariosBase = this.filtrarTalonariosAlternativo();

    // Aplicar filtrado fiscal para facturas según normativa argentina
    if (this.typeComprobante === 'factura' && this.cliente) {
      this.talariosFiltrados = this.aplicarFiltradoFiscal(talonariosBase);
    } else {
      this.talariosFiltrados = talonariosBase;
    }

    // Ordenar los talonarios filtrados por orden alfabético usando description o id como fallback
    this.talariosFiltrados = this.talariosFiltrados.sort((a, b) => {
      const nombreA = (a.description || `Talonario ${a.id}`).toLowerCase();
      const nombreB = (b.description || `Talonario ${b.id}`).toLowerCase();
      return nombreA.localeCompare(nombreB);
    });

    // Si solo hay un talonario disponible, seleccionarlo automáticamente
    if (this.talariosFiltrados.length === 1) {
      const talonarioSeleccionado = this.talariosFiltrados[0];
      
      this.form.controls.talonario.setValue(talonarioSeleccionado.id);
      
      // Configurar título inmediatamente basado en el tipo de comprobante
      this.configurarTituloSegunTipo();
      
      // Trigger manual del cambio para actualizar el sidebar
      this.onTalonarioChange(talonarioSeleccionado.id);
      
      // Obtener el número del comprobante después de seleccionar el talonario
      setTimeout(() => {
        this.getNumeroComprobante();
      }, 100);
      
    } else if (this.talariosFiltrados.length === 0) {
      // Si no hay talonarios, al menos configurar el título genérico
      this.configurarTituloSegunTipo();
    } else {
      // Si hay múltiples talonarios, solo configurar el título genérico
      this.configurarTituloSegunTipo();
    }
  }

  /**
   * Filtra talonarios basándose en la ruta URL (ventas/compras/stock) y tipo de comprobante
   * Usa receiptBookType.value como criterio principal de filtrado
   * Luego filtra por el nombre del tipo de comprobante en voucherType.voucherTypesCode.name
   */
  private filtrarTalonariosAlternativo(): ReceiptBook[] {
    console.log('🔄 EJECUTANDO FILTRADO POR PUNTO DE VENTA, TIPO DE OPERACIÓN Y TIPO DE COMPROBANTE');
    console.log('📍 Ruta actual:', window.location.pathname);
    console.log('🏢 Tipo de operación (this.type):', this.type);
    console.log('📋 Tipo de comprobante (this.typeComprobante):', this.typeComprobante);
    
    // Mapeo directo de this.type a receiptBookType.value
    const mapeoOperacion = {
      'ventas': 'sales',
      'compras': 'purchases',
      'stock': 'stock'
    };
    
    const valorReceiptBookType = mapeoOperacion[this.type];
    console.log('🎯 Buscando talonarios con receiptBookType.value =', valorReceiptBookType);

    // PASO 1: Filtrar por punto de venta ID=1 Y receiptBookType.value
    const talonariosPorOperacion = this.talonarios.filter(rb => {
      const esPuntoVentaPrincipal = rb.salesPointsId === 1;
      const tipoOperacionTalonario = rb.receiptBookType?.value;
      const coincideTipoOperacion = tipoOperacionTalonario === valorReceiptBookType;
      const cumpleCondiciones = esPuntoVentaPrincipal && coincideTipoOperacion;
      
      console.log(`📦 Talonario ID ${rb.id} "${rb.description}":`, {
        salesPointsId: rb.salesPointsId,
        esPuntoVentaPrincipal: esPuntoVentaPrincipal ? '✅' : '❌',
        'receiptBookType.value': tipoOperacionTalonario,
        coincideTipoOperacion: coincideTipoOperacion ? '✅' : '❌',
        PASO1: cumpleCondiciones ? '✅ PASA' : '❌ NO PASA'
      });
      
      return cumpleCondiciones;
    });

    console.log(`\n✅ PASO 1 COMPLETADO: ${talonariosPorOperacion.length} talonarios encontrados`);

    // PASO 2: Filtrar por tipo de comprobante específico (factura, remito, presupuesto, etc.)
    // Verifica tanto el nombre como que el receiptBookType.value coincida
    if (this.typeComprobante) {
      console.log(`\n🔍 PASO 2: Filtrando por tipo de comprobante "${this.typeComprobante}"`);
      
      // 🎯 CASO ESPECIAL: Si es pedido de COMPRAS, solo mostrar "Orden de Compra X"
      if (this.typeComprobante === 'pedido' && this.type === 'compras') {
        console.log('🎯 CASO ESPECIAL: Pedido de COMPRAS - Filtrando solo "Orden de Compra X"');
        
        const talonarioOrdenCompra = talonariosPorOperacion.filter(rb => {
          const descripcion = (rb.description || '').toLowerCase();
          
          // Buscar específicamente "Orden de Compra X"
          const esOrdenCompraX = descripcion.includes('orden de compra x') ||
                                (descripcion.includes('orden') && descripcion.includes('compra') && descripcion.includes('x'));
          
          console.log(`   📋 Talonario ID ${rb.id} "${rb.description}":`, {
            descripcion,
            esOrdenCompraX: esOrdenCompraX ? '✅ SÍ ES ORDEN DE COMPRA X' : '❌ NO',
            INCLUIDO: esOrdenCompraX ? '✅' : '❌'
          });
          
          return esOrdenCompraX;
        });
        
        if (talonarioOrdenCompra.length > 0) {
          console.log(`\n✅ RESULTADO ESPECIAL: ${talonarioOrdenCompra.length} talonario(s) "Orden de Compra X" encontrado(s)`);
          talonarioOrdenCompra.forEach(t => {
            console.log(`   ${t.id}. ${t.description}`);
          });
          return talonarioOrdenCompra;
        } else {
          console.warn('\n⚠️ No se encontró "Orden de Compra X". Buscando cualquier pedido de compra...');
          
          // Fallback: buscar cualquier pedido de compra
          const cualquierPedidoCompra = talonariosPorOperacion.filter(rb => {
            const descripcion = (rb.description || '').toLowerCase();
            const esPedido = descripcion.includes('pedido') || descripcion.includes('orden');
            return esPedido;
          });
          
          if (cualquierPedidoCompra.length > 0) {
            console.log(`✅ Fallback: ${cualquierPedidoCompra.length} pedido(s) de compra encontrado(s)`);
            return cualquierPedidoCompra;
          }
        }
      }
      
      // Filtrado normal para otros tipos de comprobantes
      const talonariosPorTipo = talonariosPorOperacion.filter(rb => {
        const voucherTypeName = rb.voucherType?.voucherTypesCode?.name || '';
        const voucherTypeDescription = rb.description || '';
        const tipoOperacionTalonario = rb.receiptBookType?.value || '';
        
        // Normalizar strings para comparación flexible (quita espacios, tildes, etc.)
        const nombreNormalizado = this.normalizarParaComparacion(voucherTypeName);
        const descripcionNormalizada = this.normalizarParaComparacion(voucherTypeDescription);
        const tipoComprobanteNormalizado = this.normalizarParaComparacion(this.typeComprobante);
        
        // Buscar el tipo de comprobante en el nombre del voucherType o en la descripción del talonario
        // Usa comparación normalizada para manejar "notadecredito" vs "Nota de Crédito"
        const nombreContieneTipo = nombreNormalizado.includes(tipoComprobanteNormalizado);
        const descripcionContieneTipo = descripcionNormalizada.includes(tipoComprobanteNormalizado);
        
        // Verificar que el receiptBookType.value coincida con el tipo de operación
        const coincideReceiptBookType = tipoOperacionTalonario === valorReceiptBookType;
        
        // Debe cumplir AMBAS condiciones: nombre correcto Y receiptBookType correcto
        const coincideTipo = (nombreContieneTipo || descripcionContieneTipo) && coincideReceiptBookType;
        
        console.log(`   📋 Talonario ID ${rb.id}:`, {
          voucherTypeName,
          nombreNormalizado,
          description: voucherTypeDescription,
          descripcionNormalizada,
          tipoComprobanteNormalizado,
          'receiptBookType.value': tipoOperacionTalonario,
          nombreContieneTipo: nombreContieneTipo ? '✅' : '❌',
          descripcionContieneTipo: descripcionContieneTipo ? '✅' : '❌',
          coincideReceiptBookType: coincideReceiptBookType ? '✅' : '❌',
          PASO2: coincideTipo ? '✅ INCLUIDO' : '❌ EXCLUIDO'
        });
        
        return coincideTipo;
      });

      console.log(`\n✅ RESULTADO FINAL: ${talonariosPorTipo.length} talonarios encontrados para:`);
      console.log(`   - Punto de Venta: Principal (ID=1)`);
      console.log(`   - Tipo de operación: ${this.type} (receiptBookType.value="${valorReceiptBookType}")`);
      console.log(`   - Tipo de comprobante: "${this.typeComprobante}"`);
      
      if (talonariosPorTipo.length > 0) {
        console.log('\n📋 Talonarios incluidos:');
        talonariosPorTipo.forEach(t => {
          console.log(`   ${t.id}. ${t.description} - ${t.voucherType?.voucherTypesCode?.name}`);
        });
        return talonariosPorTipo;
      } else {
        console.warn(`\n⚠️ No se encontraron talonarios que contengan "${this.typeComprobante}" en su nombre`);
        console.log(`✅ Devolviendo TODOS los talonarios de ${this.type} (${talonariosPorOperacion.length} encontrados)`);
        return talonariosPorOperacion;
      }
    }
    
    // Si no hay typeComprobante definido, devolver todos los de la operación
    console.log(`\n✅ RESULTADO FINAL: ${talonariosPorOperacion.length} talonarios encontrados`);
    return talonariosPorOperacion;
  }

  /**
   * Maneja el cambio de talonario seleccionado
   * @param talonarioId ID del talonario seleccionado
   */
  onTalonarioChange(talonarioId: number) {
    const talonarioSeleccionado = this.talariosFiltrados.find(t => t.id === talonarioId);
    if (talonarioSeleccionado) {
      // Usar valores por defecto cuando no hay punto de venta configurado
      const puntoVenta = talonarioSeleccionado.salesPointsId || 1;
      const numeroActual = talonarioSeleccionado.currentNumber || 1;
      
      this.punto = puntoVenta;
      this.nro = numeroActual;
      
      // Actualizar la visualización en el sidebar
      if (this.sidebar !== undefined) {
        const nombreTalonario = talonarioSeleccionado.description || `Talonario ${talonarioSeleccionado.id}`;
        const punto = this.dataService.formatearPuntoVenta(puntoVenta);
        const nro = this.dataService.formatearNumeroComprobante(numeroActual);
        this.sidebar.innerHTML = `${nombreTalonario} ${punto}-${nro}`;
        
        console.log('📋 Título actualizado:', this.sidebar.innerHTML);
      }

      // Recalcular totales porque puede haber cambiado si es Factura A o no
      if (this.cajaService.articulosList.length > 0) {
        this.sumarTotalProductos();
      }
    } else {
      console.warn('❌ No se encontró talonario con ID:', talonarioId);
    }
  }

  /**
   * Configura el título del sidebar basado en el tipo de comprobante
   */
  private configurarTituloSegunTipo() {
    if (this.sidebar !== undefined) {
      const mapeoTitulos = {
        'factura': 'Nueva Factura',
        'remito': 'Nuevo Remito',
        'presupuesto': 'Nuevo Presupuesto', 
        'pedido': 'Nuevo Pedido',
        'notadecredito': 'Nueva Nota de Crédito',
        'notadedebito': 'Nueva Nota de Débito',
        'recibo': 'Nuevo Recibo'
      };
      
      const titulo = mapeoTitulos[this.typeComprobante] || `Nuevo ${this.typeComprobante}`;
      this.sidebar.innerHTML = titulo;
    }
  }

  /**
   * Obtiene la descripción de un talonario por su ID
   * @param talonarioId ID del talonario
   * @returns Descripción del talonario o cadena vacía si no se encuentra
   */
  getDescripcionTalonario(talonarioId: number): string {
    const talonario = this.talariosFiltrados.find(t => t.id === talonarioId);
    if (!talonario) return '';
    
    return this.limpiarNombreTalonario(talonario.description || `Talonario ${talonario.id}`);
  }

  /**
   * Limpia el nombre del talonario eliminando referencias a punto de venta
   * @param descripcion Descripción original del talonario
   * @returns Descripción limpia sin referencias a PV
   */
  limpiarNombreTalonario(descripcion: string): string {
    if (!descripcion) return '';
    
    let descripcionLimpia = descripcion;
    
    // Limpiar "pv" o "PV" del nombre (con o sin espacios, paréntesis, dos puntos)
    descripcionLimpia = descripcionLimpia.replace(/\s*\(?pv\s*:?\s*\d*\)?\s*/gi, '');
    descripcionLimpia = descripcionLimpia.replace(/\s*\(?punto\s*de\s*venta\s*:?\s*\d*\)?\s*/gi, '');
    
    // Limpiar paréntesis vacíos o con solo espacios
    descripcionLimpia = descripcionLimpia.replace(/\(\s*\)/g, '');
    
    // Limpiar espacios extras y trimear
    descripcionLimpia = descripcionLimpia.trim().replace(/\s+/g, ' ');
    
    return descripcionLimpia;
  }

  /**
   * Normaliza un string para comparación flexible eliminando:
   * - Espacios, guiones, underscores
   * - Tildes y acentos
   * - Convierte a minúsculas
   * 
   * Ejemplos:
   * - "Nota de Crédito" → "notadecredito"
   * - "nota-de-credito" → "notadecredito"
   * - "FACTURA" → "factura"
   * 
   * @param texto String a normalizar
   * @returns String normalizado para comparación
   */
  normalizarParaComparacion(texto: string): string {
    if (!texto) return '';
    
    return texto
      .toLowerCase()
      .normalize('NFD') // Descompone los caracteres con tildes (é → e + ´)
      .replace(/[\u0300-\u036f]/g, '') // Elimina las marcas de tildes
      .replace(/[^a-z0-9]/g, ''); // Elimina espacios, guiones y caracteres especiales
  }

  /**
   * Verifica si hay talonarios disponibles para el tipo de comprobante actual
   * @returns true si hay talonarios disponibles, false en caso contrario
   */
  hayTalonariosDisponibles(): boolean {
    return this.talariosFiltrados && this.talariosFiltrados.length > 0;
  }

  /**
   * Obtiene la información del talonario seleccionado mostrando punto de venta y número actual
   * @returns string con el formato "0001-00000123" o vacío si no hay talonario seleccionado
   */
  getSelectedTalonarioInfo(): string {
    const talonarioId = this.form.get('talonario')?.value;
    
    if (!talonarioId) {
      return '';
    }
    
    const talonarioSeleccionado = this.talariosFiltrados.find(t => t.id === talonarioId);
    
    if (!talonarioSeleccionado || !talonarioSeleccionado.salesPointsId || !talonarioSeleccionado.currentNumber) {
      return '';
    }
    
    try {
      // Formatear el punto de venta (4 dígitos) y el número actual (8 dígitos)
      const puntoVenta = ('0000' + talonarioSeleccionado.salesPointsId.toString()).slice(-4);
      const numeroActual = ('00000000' + talonarioSeleccionado.currentNumber.toString()).slice(-8);
      
      return `${puntoVenta}-${numeroActual}`;
    } catch (error) {
      console.error('Error al formatear información del talonario:', error);
      return '';
    }
  }

  /**
   * Genera el título completo del comprobante incluyendo tipo, letra del código y número
   * @returns string con el formato "Factura B - 0001-00000123" o el tipo de comprobante si no hay talonario
   */
  getComprobanteTitle(): string {
    // Obtener el tipo de comprobante base
    let tipoBase = this.typeComprobante ? this.typeComprobante.charAt(0).toUpperCase() + this.typeComprobante.slice(1) : '';
    
    // Si tenemos typeComprobanteDB, usar su name en lugar del tipo base
    if (this.typeComprobanteDB?.name) {
      tipoBase = this.typeComprobanteDB.name;
    }
    
    // Obtener la letra del código de comprobante
    let letraComprobante = '';
    if (this.typeComprobanteDB?.voucherTypesCode?.name) {
      letraComprobante = this.typeComprobanteDB.voucherTypesCode.name;
    }
    
    // Obtener información del talonario
    const talonarioInfo = this.getSelectedTalonarioInfo();
    
    // Construir el título
    if (talonarioInfo && letraComprobante) {
      return `${tipoBase} ${letraComprobante} - ${talonarioInfo}`;
    } else if (talonarioInfo) {
      return `${tipoBase} - ${talonarioInfo}`;
    } else if (letraComprobante) {
      return `${tipoBase} ${letraComprobante}`;
    } else {
      return tipoBase;
    }
  }

  /**
   * Devuelve si el tipo seleccionado es 'porcentaje'
   */
  esTipoPorcentaje(): boolean {
    return this.tributoForm.get('tipo')?.value === 'porcentaje';
  }

  /**
   * Devuelve si el tipo seleccionado es 'monto'
   */
  esTipoMonto(): boolean {
    return this.tributoForm.get('tipo')?.value === 'monto';
  }

  /**
   * Calcula el monto en tiempo real cuando se está ingresando un porcentaje
   */
  calcularMontoDesdeePorcentaje(): number {
    const porcentaje = this.tributoForm.get('porcentaje')?.value || 0;
    return (this.subtotal * porcentaje) / 100;
  }

  /**
   * Calcula el importe del tributo seleccionado usando su alícuota
   */
  calcularImporteTributo(): number {
    if (!this.tributoSeleccionado || !this.tributoSeleccionado.alic) {
      return 0;
    }
    
    return (this.subtotal * this.tributoSeleccionado.alic) / 100;
  }

  /**
   * Calcula el importe del tributo usando el porcentaje manual ingresado
   */
  calcularImporteTributoManual(): number {
    const porcentaje = this.tributoForm.get('porcentaje')?.value || 0;
    if (porcentaje <= 0 || this.subtotal <= 0) {
      return 0;
    }
    
    return (this.subtotal * porcentaje) / 100;
  }

  /**
   * Obtiene la descripción detallada de un tributo para mostrar en la lista
   */
  getDescripcionTributo(tributo: any): string {
    if (tributo.tipo === 'porcentaje') {
      return `${tributo.porcentaje}% sobre $${tributo.aplicadoSobre?.toFixed(2) || '0.00'}`;
    }
    return 'Monto fijo';
  }

  /**
   * Se ejecuta cuando se selecciona un tributo del dropdown
   */
  onTributoSeleccionado(): void {
    const tributoId = this.tributoForm.get('tributoId')?.value;
    
    if (tributoId) {
      this.tributoSeleccionado = this.tributosDisponibles.find(t => t.id == tributoId) || null;
      
      if (this.tributoSeleccionado && this.tributoSeleccionado.alic) {
        // Configurar automáticamente como porcentaje con la alícuota
        this.tributoForm.patchValue({
          tipo: 'porcentaje',
          porcentaje: this.tributoSeleccionado.alic
        });
      }
    } else {
      this.tributoSeleccionado = null;
    }
  }

  /**
   * Verifica si el tributo seleccionado tiene configuración predefinida
   */
  tieneConfiguracionPredefinida(): boolean {
    if (!this.tributoSeleccionado) {
      return false;
    }
    
    // Verificar si tiene alícuota predefinida
    return !!(this.tributoSeleccionado.alic && this.tributoSeleccionado.alic > 0);
  }

  /**
   * Verifica si se puede agregar el tributo
   */
  puedeAgregarTributo(): boolean {
    const tributoId = this.tributoForm.get('tributoId')?.value;
    const porcentaje = this.tributoForm.get('porcentaje')?.value;
    
    // Debe haber seleccionado un tributo válido y debe haber ingresado un porcentaje mayor a 0
    return !!(tributoId && this.tributoSeleccionado && porcentaje > 0);
  }

  /**
   * Maneja el cambio de unidad de medida en un producto
   * Actualiza el precio según la unidad seleccionada si existe esa información
   */
  onUnitChange(product: any, newUnitId: any) {
    if (!product.conversionUnits || product.conversionUnits.length === 0) {
      return;
    }

    // Buscar la nueva unidad seleccionada
    const selectedUnit = product.conversionUnits.find(unit => unit.id === newUnitId);
    
    if (selectedUnit) {
      // Actualizar el ID de la unidad seleccionada
      product.conversionUnitId = newUnitId;
      
      // Si la unidad tiene un precio específico y es diferente al actual, actualizar
      if (selectedUnit.price && selectedUnit.price > 0 && selectedUnit.price !== product.unitPrice) {
        product.unitPrice = selectedUnit.price;
      }
      
      // Recalcular los totales
      this.sumarTotalProductos();
      
      // Log para debugging (remover en producción)
      console.log('Unidad cambiada:', {
        producto: product.description,
        unidadSeleccionada: selectedUnit.measurementUnit?.name,
        precio: selectedUnit.price,
        cantidad: selectedUnit.quantity
      });
    }
  }

  /**
   * Obtiene el texto descriptivo para mostrar en el select de unidades
   * Incluye información de conversión para unidades compuestas
   */
  getUnitDisplayText(unit: any): string {
    if (!unit.measurementUnit) {
      return 'Unidad';
    }
    
    let displayText = unit.measurementUnit.name;
    
    // Si es una unidad compuesta (quantity !== 1 y tiene unidad base diferente)
    if (unit.quantity && unit.quantity !== 1 && 
        unit.baseMeasurementUnit && 
        unit.baseMeasurementUnit.id !== unit.measurementUnit.id) {
      displayText += ` (${unit.quantity} ${unit.baseMeasurementUnit.name})`;
    }
    
    return displayText;
  }

  /**
   * Obtiene el nombre de la unidad de medida de un producto
   * Busca en diferentes ubicaciones del objeto según la estructura de datos
   */
  getProductUnitName(product: any): string {
    console.log('getProductUnitName llamado para producto:', {
      code: product.code,
      description: product.description,
      measurementUnit: product.measurementUnit,
      'article.measurementUnit': product.article?.measurementUnit,
      measurementUnitId: product.measurementUnitId,
      'article.measurementUnitId': product.article?.measurementUnitId
    });
    
    // Prioridad 1: unidad directa del producto
    if (product.measurementUnit?.name) {
      console.log('Usando unidad directa del producto:', product.measurementUnit.name);
      return product.measurementUnit.name;
    }
    
    // Prioridad 2: unidad desde el objeto article anidado
    if (product.article?.measurementUnit?.name) {
      console.log('Usando unidad del artículo anidado:', product.article.measurementUnit.name);
      return product.article.measurementUnit.name;
    }
    
    // Prioridad 3: buscar en la lista de medidas disponibles usando measurementUnitId
    const measurementUnitId = product.measurementUnitId || product.article?.measurementUnitId;
    if (measurementUnitId && this.medidas && this.medidas.length > 0) {
      const unidadEncontrada = this.medidas.find(u => u.id === measurementUnitId);
      if (unidadEncontrada) {
        console.log('Usando unidad encontrada en lista de medidas:', unidadEncontrada.name);
        return unidadEncontrada.name;
      }
    }
    
    // Fallback final
    console.log('Usando fallback UNIDAD');
    return 'UNIDAD';
  }

  /**
   * Fuerza el procesamiento de unidades para un producto
   * Se llama desde el template para asegurar que las unidades estén procesadas
   */
  ensureUnitsProcessed(product: any): string {
    if (product && (!product.conversionUnits || product.conversionUnits.length === 0)) {
      console.log('Forzando procesamiento de unidades para:', product.code);
      this.asegurarUnidadesConversion(product);
    }
    return ''; // Retorna string vacío para no afectar el template
  }

  /**
   * Obtiene el nombre de una unidad de medida por su ID
   * Busca en la lista de medidas disponibles (this.medidas)
   */
  getUnitNameById(unitId: any): string {
    console.log(`getUnitNameById llamado con ID: ${unitId}`);
    
    if (!unitId) {
      console.log('getUnitNameById: No unitId provided');
      return 'UNIDAD';
    }

    if (!this.medidas || this.medidas.length === 0) {
      console.log('getUnitNameById: No medidas available');
      return 'UNIDAD';
    }

    console.log('Medidas disponibles:', this.medidas.map(m => `ID: ${m.id}, Name: ${m.name}`));

    const unidad = this.medidas.find(u => u.id === unitId);
    if (unidad) {
      console.log(`getUnitNameById: Encontrada unidad para ID ${unitId}:`, unidad.name);
      return unidad.name;
    }

    console.log(`getUnitNameById: No se encontró unidad para ID ${unitId}`);
    console.log('IDs disponibles:', this.medidas.map(m => m.id));
    return 'UNIDAD';
  }

  /**
   * Helper para debug: obtiene el número de medidas disponibles
   */
  getMedidasCount(): number {
    return this.medidas ? this.medidas.length : 0;
  }

  /**
   * Maneja el cambio de unidad de medida para un producto
   * Se ejecuta cuando el usuario selecciona una unidad diferente en el select
   */
  onMeasurementUnitChange(product: any, newMeasurementUnitId: any) {
    console.log('onMeasurementUnitChange:', {
      productCode: product.code,
      oldMeasurementUnitId: product.measurementUnitId,
      newMeasurementUnitId: newMeasurementUnitId
    });

    if (newMeasurementUnitId) {
      // Actualizar el measurementUnitId del producto
      product.measurementUnitId = newMeasurementUnitId;

      // Buscar la unidad seleccionada en la lista de medidas
      const unidadSeleccionada = this.medidas.find(u => u.id === newMeasurementUnitId);
      if (unidadSeleccionada) {
        // Actualizar el objeto measurementUnit del producto
        product.measurementUnit = unidadSeleccionada;
        
        console.log('Unidad actualizada:', {
          id: unidadSeleccionada.id,
          name: unidadSeleccionada.name
        });
      }

      // También actualizar conversionUnitId para mantener consistencia
      product.conversionUnitId = newMeasurementUnitId;
    }
  }

  /**
   * Obtiene el ID de la unidad de medida seleccionada para un producto
   * Incluye lógica de debugging y fallbacks
   */
  getSelectedMeasurementUnitId(product: any): any {
    // Prioridad 1: measurementUnitId directo
    let selectedId = product.measurementUnitId;
    
    // Prioridad 2: measurementUnitId desde article anidado
    if (!selectedId && product.article?.measurementUnitId) {
      selectedId = product.article.measurementUnitId;
    }

    // Prioridad 3: fallback a conversionUnitId si las anteriores no están disponibles
    // Esto corrige casos donde el producto trae sólo conversionUnitId (ej.: Litros)
    if (!selectedId && product.conversionUnitId) {
      selectedId = product.conversionUnitId;
    }

    // Debug: Solo para el producto de aceite
    if (product.code === '000010') {
      console.log('getSelectedMeasurementUnitId para aceite:', {
        code: product.code,
        measurementUnitId: product.measurementUnitId,
        'article.measurementUnitId': product.article?.measurementUnitId,
        selectedId: selectedId,
        medidasDisponibles: this.medidas?.length || 0
      });
      
      // Verificar si el selectedId existe en las medidas disponibles
      if (selectedId && this.medidas) {
        const unidadEncontrada = this.medidas.find(u => u.id === selectedId);
        console.log('Unidad encontrada en medidas:', unidadEncontrada);
      }
    }

  return selectedId;
  }

  /**
   * Determina si el talonario actual debe preservarse al seleccionar un cliente
   * @param talonarioActual ID del talonario actualmente seleccionado
   * @returns true si debe preservarse, false si debe resetearse
   */
  private debePreservarTalonarioActual(talonarioActual: any): boolean {
    // Si no hay talonario seleccionado, no hay nada que preservar
    if (!talonarioActual) {
      return false;
    }

    // Buscar el talonario en la lista filtrada
    const talonario = this.talariosFiltrados.find(t => t.id === talonarioActual);
    if (!talonario) {
      return false;
    }

    // Preservar talonarios de presupuesto
    if (this.typeComprobante === 'presupuesto') {
      const descripcion = (talonario.description || '').toLowerCase();
      const esPresupuesto = descripcion.includes('presupuesto') || 
                           descripcion.includes('budget') || 
                           descripcion.includes('quotation') ||
                           talonario.voucherType?.voucherTypesCode?.name?.toLowerCase().includes('presupuesto');
      
      if (esPresupuesto) {
        console.log('Preservando talonario de presupuesto:', talonario.description);
        return true;
      }
    }

    // Preservar talonarios de pedido
    if (this.typeComprobante === 'pedido') {
      const descripcion = (talonario.description || '').toLowerCase();
      const esPedido = descripcion.includes('pedido') || 
                      descripcion.includes('order') ||
                      talonario.voucherType?.voucherTypesCode?.name?.toLowerCase().includes('pedido');
      
      if (esPedido) {
        console.log('Preservando talonario de pedido:', talonario.description);
        return true;
      }
    }

    // Preservar talonarios de remito
    if (this.typeComprobante === 'remito') {
      const descripcion = (talonario.description || '').toLowerCase();
      const esRemito = descripcion.includes('remito') || 
                      descripcion.includes('delivery') ||
                      talonario.voucherType?.voucherTypesCode?.name?.toLowerCase().includes('remito');
      
      if (esRemito) {
        console.log('Preservando talonario de remito:', talonario.description);
        return true;
      }
    }

    // Por defecto, no preservar para otros tipos de comprobante
    return false;
  }

  /**
   * Determina si un concepto es de tipo "Productos"
   * @param concepto El concepto a verificar
   * @returns true si el concepto es de tipo productos
   */
  private esConceptoDeProductos(concepto: any): boolean {
    if (!concepto || !concepto.description) {
      return false;
    }
    
    const description = concepto.description.toLowerCase();
    return description === 'productos' || 
           description === 'producto' ||
           description.includes('producto');
  }

  /**
   * Obtiene el nombre del tipo de comprobante para mostrar al usuario
   * @returns El nombre del tipo de comprobante
   */
  private getTipoComprobanteDisplay(): string {
    const tiposComprobante = {
      'factura': 'Factura',
      'presupuesto': 'Presupuesto',
      'pedido': 'Pedido',
      'remito': 'Remito',
      'notadecredito': 'Nota de Crédito',
      'notadedebito': 'Nota de Débito',
      'recibo': 'Recibo'
    };
    
    return tiposComprobante[this.typeComprobante] || 'Comprobante';
  }

  /**
   * Imprime el comprobante recién creado
   * @param comprobanteData Datos del comprobante devueltos por el servidor
   */
  private imprimirComprobante(comprobanteData: any): void {
    const tipoComprobante = this.getTipoComprobanteDisplay();
    
    // Obtener información de la empresa antes de generar el contenido
    this.empresaService.getEmpresaConfig().pipe(
      catchError(error => {
        console.warn('No se pudo obtener información de la empresa, usando valores por defecto:', error);
        return of({
          socialReason: 'KOCURSOFT - ERP PYMES',
          commercialAddress: '',
          documentNumber: '',
          phone: '',
          email: ''
        });
      })
    ).subscribe(empresaData => {
      const contenidoImpresion = this.impresionService.generarContenidoImpresion(comprobanteData, tipoComprobante, empresaData, {
        cliente: this.cliente,
        form: this.form,
        talariosFiltrados: this.talariosFiltrados,
        articulosList: this.cajaService.articulosList,
        typeComprobante: this.typeComprobante,
        typeComprobanteDB: this.typeComprobanteDB,
        subtotal: this.subtotal,
        bonificacion: this.bonificacion,
        impuestos: this.impuestos,
        total: this.total
      });
      
      // Abrir ventana de impresión
      const ventanaImpresion = window.open('', '_blank');
      
      if (ventanaImpresion) {
        ventanaImpresion.document.write(contenidoImpresion);
        ventanaImpresion.document.close();
        
        // Esperar a que la ventana esté lista y luego imprimir
        ventanaImpresion.onload = () => {
          setTimeout(() => {
            ventanaImpresion.print();
            ventanaImpresion.close();
          }, 250);
        };
      } else {
        Swal.fire({
          title: 'Error',
          text: 'No se pudo abrir la ventana de impresión. Verifique que las ventanas emergentes estén habilitadas.',
          icon: 'warning',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#fbc658'
        });
      }
    });
  }

  /**
   * Imprime el comprobante actual (para uso en modo edición)
   */
  imprimirComprobanteActual(): void {
    if (!this.comprobanteId) {
      Swal.fire({
        title: 'Error',
        text: 'No se puede imprimir: ID de comprobante no encontrado',
        icon: 'error',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#ef8157'
      });
      return;
    }

    // Obtener datos del comprobante actual y usar la función propia de generarContenidoImpresion
    this.comprobanteSerice.getComprobanteById(this.comprobanteId).subscribe({
      next: (comprobanteData) => {
        if (comprobanteData) {
          const tipoComprobante = this.getTipoComprobanteDisplay();
          
          // Obtener información de la empresa y generar contenido usando la función propia
          this.empresaService.getEmpresaConfig().pipe(
            catchError(error => {
              console.warn('No se pudo obtener información de la empresa, usando valores por defecto:', error);
              return of({
                socialReason: 'KOCURSOFT - ERP PYMES',
                commercialAddress: '',
                documentNumber: '',
                phone: '',
                email: ''
              });
            })
          ).subscribe(empresaData => {
            // Usar la función generarContenidoImpresion del servicio de impresión
            const contextData = {
              cliente: this.cliente,
              form: this.form,
              talariosFiltrados: this.talariosFiltrados,
              articulosList: this.cajaService.articulosList,
              typeComprobante: this.typeComprobante,
              typeComprobanteDB: this.typeComprobanteDB,
              subtotal: this.subtotal,
              bonificacion: this.bonificacion,
              impuestos: this.impuestos,
              total: this.total
            };
            
            const contenidoImpresion = this.impresionService.generarContenidoImpresion(comprobanteData, tipoComprobante, empresaData, contextData);
            
            // Mostrar diálogo de confirmación y ejecutar impresión
            Swal.fire({
              title: 'Imprimir Comprobante',
              text: '¿Deseas imprimir este comprobante?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: 'Imprimir',
              cancelButtonText: 'Cancelar',
              confirmButtonColor: '#102dd3',
              cancelButtonColor: '#6c757d'
            }).then((result) => {
              if (result.isConfirmed) {
                // Abrir ventana de impresión
                const ventanaImpresion = window.open('', '_blank');
                
                if (ventanaImpresion) {
                  ventanaImpresion.document.write(contenidoImpresion);
                  ventanaImpresion.document.close();
                  
                  // Esperar a que la ventana esté lista y luego imprimir
                  ventanaImpresion.onload = () => {
                    setTimeout(() => {
                      ventanaImpresion.print();
                      ventanaImpresion.close();
                    }, 250);
                  };
                } else {
                  Swal.fire({
                    title: 'Error',
                    text: 'No se pudo abrir la ventana de impresión. Verifique que las ventanas emergentes estén habilitadas.',
                    icon: 'warning',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#fbc658'
                  });
                }
              }
            });
          });
        } else {
          Swal.fire({
            title: 'Error',
            text: 'No se pudieron obtener los datos del comprobante',
            icon: 'error',
            confirmButtonText: 'Entendido',
            confirmButtonColor: '#ef8157'
          });
        }
      },
      error: (error) => {
        console.error('Error al obtener datos del comprobante:', error);
        Swal.fire({
          title: 'Error',
          text: 'Error al cargar los datos del comprobante para impresión',
          icon: 'error',
          confirmButtonText: 'Entendido',
          confirmButtonColor: '#ef8157'
        });
      }
    });
  }

  // ================================
  // MÉTODOS PARA TOTALES FLOTANTES
  // ================================

  /**
   * Inicializa el sistema de totales flotantes
   */
  private initTotalesFlotantes(): void {
    // Añadir evento de scroll para controlar la visibilidad de los totales flotantes
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Configurar observer para detectar cuando el elemento de totales sale de la vista
    setTimeout(() => {
      this.setupIntersectionObserver();
    }, 1000); // Esperar a que el DOM esté completamente cargado
  }

  /**
   * Limpia los eventos y observers de los totales flotantes
   */
  private destroyTotalesFlotantes(): void {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  /**
   * Maneja el evento de scroll para mostrar/ocultar totales flotantes
   */
  private handleScroll(): void {
    const totalesOriginal = document.getElementById('totales-section');
    const totalesFlotantes = document.getElementById('totales-flotantes');
    
    if (!totalesOriginal || !totalesFlotantes) {
      return;
    }

    const rect = totalesOriginal.getBoundingClientRect();
    const isOriginalVisible = rect.top < window.innerHeight && rect.bottom > 0;
    
    // Mostrar totales flotantes cuando los originales no están visibles y hay scroll
    const shouldShow = !isOriginalVisible && window.scrollY > this.scrollThreshold && this.cajaService.articulosList.length > 0;
    
    if (shouldShow) {
      totalesFlotantes.classList.add('visible');
      document.body.classList.add('totales-flotantes-activos');
    } else {
      totalesFlotantes.classList.remove('visible');
      document.body.classList.remove('totales-flotantes-activos');
    }
  }

  /**
   * Configura el Intersection Observer para detectar cuando los totales salen de vista
   */
  private setupIntersectionObserver(): void {
    const totalesSection = document.getElementById('totales-section');
    const totalesFlotantes = document.getElementById('totales-flotantes');
    
    if (!totalesSection || !totalesFlotantes) {
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const shouldShow = !entry.isIntersecting && this.cajaService.articulosList.length > 0;
        
        if (shouldShow) {
          totalesFlotantes.classList.add('visible', 'animate-in');
          document.body.classList.add('totales-flotantes-activos');
        } else {
          totalesFlotantes.classList.remove('visible', 'animate-in');
          document.body.classList.remove('totales-flotantes-activos');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });

    observer.observe(totalesSection);
  }

  /**
   * Alterna entre mostrar y ocultar el contenido de los totales flotantes
   */
  toggleTotalesFlotantes(): void {
    this.totalesFlotantesMinimizados = !this.totalesFlotantesMinimizados;
    
    // Guardar la preferencia del usuario en localStorage
    localStorage.setItem('totalesFlotantesMinimizados', this.totalesFlotantesMinimizados.toString());
  }

}
